import { Component, OnInit, ViewChild, ElementRef, HostListener, OnDestroy, ChangeDetectorRef } from '@angular/core';
import * as THREE from 'three';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { STLExporter } from 'three/examples/jsm/exporters/STLExporter';
import { PLYExporter } from 'three/examples/jsm/exporters/PLYExporter';
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls';

//Outline
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { Matrix4, Mesh, Vector2, Vector3 } from 'three';
import { ScanService } from '../../services/scan.service';
import Swal from 'sweetalert2';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ScanFile } from '../../models/file.model';
import { Location } from '@angular/common';
import { Options, LabelType } from '@angular-slider/ngx-slider';
import textFont from 'three/examples/fonts/gentilis_bold.typeface.json';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { TranslateService } from '@ngx-translate/core';
import { ViewHelper } from 'three/examples/jsm/helpers/ViewHelper.js'
import jsPDF from 'jspdf';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { WebsocketService } from 'src/app/services/post-process-websocket.service';
import { RefundService } from 'src/app/services/refund.service';
import { MeshlabService } from 'src/app/services/meshlab.service';
import { HttpEventType } from '@angular/common/http';
import { ClientsService } from 'src/app/services/clients.service';
import { scanProcessingProperties } from 'src/app/models/client.model';
import { ProductSelectorComponent, Product3DToDesign } from '../product-selector/product-selector.component';


interface ColorLegend {
  distance: number;
  color: THREE.Color;
}

enum clippingSides {
  over,
  under,
  leftSide,
  rightSide,
  front,
  back
}


interface sliderOption {
  type: clippingSides
  value: number,
  options: Options
}

interface sliderProductOption {
  type: string
  value: number,
  options: Options
}

export enum Color_Pedigrafia {
  Blue = 'blue',
  RedYellowBlue = 'red_yellow_blue'
}



@Component({
  selector: 'app-three-viewer',
  standalone: true,
  imports: [SharedModule, ProductSelectorComponent],
  templateUrl: './three-viewer.component.html',
  styleUrl: './three-viewer.component.scss'
})
export class ThreeViewerComponent implements OnInit, OnDestroy {
  @ViewChild('rendererContainer') rendererContainer: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;
  @ViewChild('stepper', { static: false }) stepper: any;
  @ViewChild('productSelector') productSelector!: ProductSelectorComponent;

  selectedFile = '';
  public customLogo = "../../../assets/images/logos/wiky-solutions.png";
  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {

    var proporcionCorrecta = 3;
    var auxProporcion = window.innerHeight / window.innerWidth;
    var viewportH, viewPortW;
    if (auxProporcion <= proporcionCorrecta) {
      viewportH = 400 / 2;
      viewPortW = (400 / auxProporcion) / 2;
    } else {
      viewportH = (400 / auxProporcion) / 2;
      viewPortW = 400 / 2;
    }

    this.camera.updateProjectionMatrix();

    this.renderer.setSize(window.innerWidth, window.innerHeight);
    if (this.compose) {
      this.compose.setSize(window.innerWidth, window.innerHeight);
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    const keyPressed = event.key.toLocaleLowerCase();
    if (keyPressed === "a") {
      this.startAlignment();
    } else if (keyPressed === "g") {
    } else if (keyPressed === "r") {
      this.rotate180();
    } else if (keyPressed === "c") {
      this.initCutPlanes();
    } else if (keyPressed == "i") {
      this.invertScan();
    } else if (keyPressed === "e") {
      this.control.setMode('rotate');
    }
  }

  renderer = new THREE.WebGLRenderer({ alpha: true, preserveDrawingBuffer: true, antialias: true });
  scene: THREE.Scene = null;
  sceneLinesHelper: THREE.Scene = null;
  camera: THREE.OrthographicCamera | THREE.PerspectiveCamera = null;
  mesh: THREE.Mesh = null;
  skeleton: THREE.SkeletonHelper = null;
  aligning: boolean = false;

  addingCircles: boolean = false;
  circleToMove: THREE.Mesh = null;

  addingArchPoints: boolean = false;
  archPointsSline: THREE.Vector3[] = null;

  cropping: boolean = false;
  croppingPoints: THREE.Vector3[] = []


  orbit: OrbitControls;
  helper: any;
  clock: THREE.Clock;
  control: TransformControls;
  aligningPoints: THREE.Vector3[] = [];
  textInfoAligning: string = '';
  nextPointToSelectForAlignment: string = '';
  scanId: string;
  fileName: string;
  fileIndex: number;
  scanFiles: ScanFile[] = [];
  files: ScanFile[] = []
  fileLoaded: ScanFile;
  aligned: boolean = false;
  cropped: boolean = false;
  clippingPlanes: THREE.Plane[];
  boundingBox: THREE.BoxHelper;
  textureLoaded: boolean = false;

  heightClippingPlane: THREE.Plane;
  fingersClippingPlane: THREE.Plane;
  heelClippingPlane: THREE.Plane;
  underFootClippingPlane: THREE.Plane;
  leftSideFootClippingPlane: THREE.Plane;
  rightSideFootClippingPlane: THREE.Plane;

  // Para perimetro
  pointOfIntersection = new THREE.Vector3();
  pointsOfIntersection: THREE.Vector3[] = [];

  // Foot circumference measurements
  ballCircumferencePoints: THREE.Vector3[] = []
  instepCircumferencePoints: THREE.Vector3[] = []
  longHeelCircumferencePoints: THREE.Vector3[] = []
  shortHeelCircumferencePoints: THREE.Vector3[] = []
  ankleCircumferencePoints: THREE.Vector3[] = []
  testCircumferencePoints: THREE.Vector3[] = []

  // Foot measurements
  plantarFootMeasurements: {
    length: number,
    metatarsalSupport: number
  } = {
      length: 0,
      metatarsalSupport: 0
    }

  //Outline
  compose: EffectComposer

  // Degradation legend
  degradationColors: ColorLegend[] = []

  isIpad: Boolean = false;
  canGoBack: boolean = false;

  postProcessing: {
    fillHoles: boolean,
    reconstructionDepth: number,
    removeSmallParts: boolean,
    mergeCloseVertices: boolean,
    smooth: boolean,
    smoothSteps: number
  } = {
      fillHoles: true,
      reconstructionDepth: 10,
      removeSmallParts: true,
      mergeCloseVertices: true,
      smooth: true,
      smoothSteps: 6
    }

  smoothStepsOptions: Options = {
    floor: 4,
    ceil: 16,
    step: 2,
    showTicks: true,
    showTicksValues: true
  };

  reconstructionDepthOptions: Options = {
    floor: 8,
    ceil: 12,
    step: 2,
    showTicks: true,
    showTicksValues: true
  };

  meshDeform = [
    {
      type: "first",
      value: 0,
      options: {
        floor: -100,
        ceil: 100,

        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>First</b> ' + value;
            case LabelType.High:
              return '<b>First</b> ' + value;
            default:
              return `${value}`;
          }
        },
      }
    },
    {
      type: "second",
      value: 0,
      options: {
        floor: -100,
        ceil: 100,

        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>Second</b> ' + value;
            case LabelType.High:
              return '<b>Second</b> ' + value;
            default:
              return `${value}`;
          }
        },
      }
    },
    {
      type: "third",
      value: 0,
      options: {
        floor: -100,
        ceil: 100,

        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>Third</b> ' + value;
            case LabelType.High:
              return '<b>Third</b> ' + value;
            default:
              return `${value}`;
          }
        },
      }
    }
  ]

  sliderOptions: sliderOption[] = [
    {
      type: clippingSides.over,
      value: 50,
      options: {
        floor: 0,
        ceil: 500,

        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>' + this.getClippingSideLabel(clippingSides.over) + '</b> ' + value;
            case LabelType.High:
              return '<b>' + this.getClippingSideLabel(clippingSides.over) + '</b> ' + value;
            default:
              return `${value}`;
          }
        },
      }
    },
    {
      type: clippingSides.under,
      value: 5,
      options: {
        floor: 0,
        ceil: 50,
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>' + this.getClippingSideLabel(clippingSides.under) + '</b> ' + value;
            case LabelType.High:
              return '<b>' + this.getClippingSideLabel(clippingSides.under) + '</b> ' + value;
            default:
              return `${value}`;
          }
        }
      }
    },
    {
      type: clippingSides.leftSide,
      value: 50,
      options: {
        floor: 0,
        ceil: 200,
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>' + this.getClippingSideLabel(clippingSides.leftSide) + '</b> ' + value;
            case LabelType.High:
              return '<b>' + this.getClippingSideLabel(clippingSides.leftSide) + '</b> ' + value;
            default:
              return `${value}`;
          }
        }
      }
    },
    {
      type: clippingSides.rightSide,
      value: 50,
      options: {
        floor: 0,
        ceil: 200,
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>' + this.getClippingSideLabel(clippingSides.rightSide) + '</b> ' + value;
            case LabelType.High:
              return '<b>' + this.getClippingSideLabel(clippingSides.rightSide) + '</b> ' + value;
            default:
              return `${value}`;
          }
        }
      }
    },
    {
      type: clippingSides.front,
      value: 270,
      options: {
        floor: 0,
        ceil: 500,
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>' + this.getClippingSideLabel(clippingSides.front) + '</b> ' + value;
            case LabelType.High:
              return '<b>' + this.getClippingSideLabel(clippingSides.front) + '</b> ' + value;
            default:
              return `${value}`;
          }
        }
      }
    },
    {
      type: clippingSides.back,
      value: 60,
      options: {
        floor: 0,
        ceil: 200,
        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>' + this.getClippingSideLabel(clippingSides.back) + '</b> ' + value;
            case LabelType.High:
              return '<b>' + this.getClippingSideLabel(clippingSides.back) + '</b> ' + value;
            default:
              return `${value}`;
          }
        }
      }
    }
  ]

  productGenerator: { arch: number, archModification: number, sliceType: number, reinforcementPosition: number, tipoDeAgujeros: number } = {
    arch: 0,
    archModification: 0,
    sliceType: 0,
    reinforcementPosition: 0,
    tipoDeAgujeros: 0
  }

  productGeneratorSlider: sliderProductOption[] = [
    {
      type: "Arch",
      value: 0,
      options: {
        floor: -5,
        ceil: 5,

        translate: (value: number, label: LabelType): string => {
          switch (label) {
            case LabelType.Low:
              return '<b>Arch</b> ' + value + ' mm';
            case LabelType.High:
              return '<b>Arch</b> ' + value + ' mm';
            default:
              return `${value}`;
          }
        },
      }
    },
  ]

  clippingSizes: { over: number, under: number, leftSide: number, rightSide: number, heel: number, fingers: number };

  // colors of pedigrafia
  savedColor: string;

  // Rotations and transfmations by client
  rotationsAndTransformations: scanProcessingProperties = null

  showSetLandmarksStep: boolean = true
  allStepsCompleted: boolean = false
  currentStepIndex: number = 0

  // Propiedades individuales para cada paso
  step1Completed: boolean = false
  step2Completed: boolean = false
  step3Completed: boolean = false

  async connectSocket() {
  }

  constructor(
    private scanService: ScanService,
    private route: ActivatedRoute,
    public websocketService: WebsocketService,
    private location: Location,
    private refundService: RefundService,
    private meshlabService: MeshlabService,
    private translateService: TranslateService,
    private router: Router,
    private clientService: ClientsService,
    private cdr: ChangeDetectorRef
  ) {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateCanGoBack();
      }
    });

    // Colores pedigrafia
    this.savedColor = localStorage.getItem('color');
    if (!this.savedColor) {
      this.savedColor = "blue"
    }


    this.clippingSizes = {
      over: 50, under: -5, leftSide: 60, rightSide: -60, heel: 60, fingers: -270
    }

    this.renderer.autoClear = false;
    //Clipping planes
    this.initClippingPlanes();

    // Get the scanId
    const routeParams = this.route.snapshot.paramMap;
    this.scanId = routeParams.get('scanId');
    this.fileName = routeParams.get('fileName');
    this.fileIndex = Number(routeParams.get('index'));

    this.loadFiles();

    this.scene = new THREE.Scene();
    this.sceneLinesHelper = new THREE.Scene()

    // Floor plane
    this.addFloorPlane();

    this.camera = new THREE.PerspectiveCamera(35, window.innerWidth / window.innerHeight, 1, 10000);
    this.camera.position.set(0, -1000, 180);
    this.camera.up.set(0, 0, 1);
    this.camera.lookAt(new THREE.Vector3(100, 0, 0));

    // Directional Light
    this.directionalLight();

    // Init circle to move
    const geometry = new THREE.CircleGeometry(10, 32);
    const material = new THREE.MeshBasicMaterial({ color: 0xffff00, side: THREE.DoubleSide });
    const circle = new THREE.Mesh(geometry, material);
    circle.position.set(0, 0, 0)
    this.circleToMove = circle

    // Controls
    this.orbit = new OrbitControls(this.camera, this.renderer.domElement)

    // helper
    this.helper = new ViewHelper(this.camera, this.renderer.domElement);
    this.helper.controls = this.orbit;
    this.helper.controls.center = this.orbit.target;
    this.clock = new THREE.Clock();


    // Chekc if is iPad or not
    // console.log("USER AGENT: ", navigator.userAgent)
    const isTouchDevice = 'ontouchstart' in window;
    // console.log("touchable: ", isTouchDevice)
    // const isIpad = /iPad/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
    if (isTouchDevice) {
      this.isIpad = true;
    } else {
      this.isIpad = false;
    }

    // Check custom logo
    this.checkIfHasCustomLogo();
  }

  resetStepper(): void {
    const targetStep = this.showSetLandmarksStep ? 0 : 1;

    // Actualizar el índice del paso actual
    this.currentStepIndex = targetStep;

    if (this.stepper) {
      this.stepper.activeStep = targetStep;

      if (this.showSetLandmarksStep) {
        console.log('✅ Stepper set to step 0 (Set Landmarks) - no landmarks detected');
      } else {
        console.log('✅ Stepper set to step 1 (Modify Scan) - landmarks already exist');
        this.step1Completed = true
      }

    } else {
      console.warn('⚠️ Stepper not available in resetStepper, but currentStepIndex updated');
    }
  }

  getClippingSideLabel(side: clippingSides): string {
    const labels: { [key in clippingSides]: string } = {
      [clippingSides.over]: this.translateService.instant('CLIPPING_SIDES.over'),
      [clippingSides.under]: this.translateService.instant('CLIPPING_SIDES.under'),
      [clippingSides.leftSide]: this.translateService.instant('CLIPPING_SIDES.leftSide'),
      [clippingSides.rightSide]: this.translateService.instant('CLIPPING_SIDES.rightSide'),
      [clippingSides.front]: this.translateService.instant('CLIPPING_SIDES.front'),
      [clippingSides.back]: this.translateService.instant('CLIPPING_SIDES.back')
    };
    return labels[side];
  }

  ngOnDestroy(): void {

  }

  checkIfHasCustomLogo() {
    if (localStorage.getItem('customLogo')) {
      this.customLogo = localStorage.getItem('customLogo');
    }
  }

  handleClick(event: PointerEvent) {
    this.helper.handleClick(event)
  }

  // guardar color de pedigrafia
  saveColor(color: string) {
    localStorage.setItem('color', color);
    this.savedColor = color;
  }


  startAlignment() {
    this.aligningPoints = [];

    if (!this.aligned) {
      if (this.aligningPoints.length === 0) {
        this.aligning = true
        this.nextPointToSelectForAlignment = 'Heel'
        this.textInfoAligning = "Aligning ..."
      }
    } else {
      Swal.fire('对齐', '如果已对齐，请重新加载扫描文件以再次对齐。', 'warning')
    }
  }

  generateColorLegend() {
    const baseColor = new THREE.Color(59 / 255, 92 / 255, 130 / 255);
    const colors: ColorLegend[] = [];

    for (let distance = 0; distance <= 50; distance += 10) {
      let color: THREE.Color;
      if (distance < 5) {
        color = baseColor.clone();
      } else if (distance < 50) {
        const t = Math.pow((distance - 5) / 45, 0.5);
        color = baseColor.clone().lerp(new THREE.Color(1, 1, 1), t);
      } else {
        color = new THREE.Color(0, 0, 1);
      }

      colors.push({ distance, color });
    }

    this.degradationColors = colors
  }


  loadFiles() {
    // Get files
    this.scanService.getFiles(this.scanId).subscribe((files) => {

      // save all the files of the scan
      this.scanFiles = files;

      // Filtrar archivos por tipo
      this.files = files.filter((file) => file.type === "stl" || file.type === "ply" && file.name.includes('processed') || file.type === "obj");

      this.scanService.getOne(this.scanId).subscribe({
        next: (scanFound) => {
          if (scanFound.data?.Landmarks && scanFound.data.Landmarks.length > 0) {

            this.showSetLandmarksStep = false
            this.step1Completed = true
            this.setStepperToStep1();
          }

          this.clientService.getClientById(scanFound.clientId).subscribe({
            next: (clientFound) => {
              this.rotationsAndTransformations = clientFound.scanProcessingProperties
            }
          })
        }
      })

      // Si tiene archivos, cargar el primero o el archivo predeterminado
      if (this.files.length > 0) {
        this.loadDefaultFile(this.files);
      }

    });
  }

  loadDefaultFile(fileArray: any[]) {
    // Si se tiene un archivo predeterminado, cargarlo
    if (this.fileName) {
      let foundFile = fileArray.find((fileToFind) => fileToFind.name.includes(this.fileName));
      if (foundFile) {
        this.onFileSelectedChange(foundFile.name);
      }
    } else {
      // Cargar el primer archivo si no hay uno predeterminado
      this.onFileSelectedChange(fileArray[this.fileIndex ? this.fileIndex : 0].name);
    }
  }

  changeClippingValue(value, clippingType: clippingSides) {

    switch (clippingType) {
      case clippingSides.over:
        this.heightClippingPlane.constant = value
        this.clippingSizes.over = value;

        break;
      case clippingSides.under:
        this.underFootClippingPlane.constant = value
        this.clippingSizes.under = -Math.abs(value)
        break;
      case clippingSides.leftSide:
        this.leftSideFootClippingPlane.constant = value
        this.clippingSizes.rightSide = -Math.abs(value)
        break;
      case clippingSides.rightSide:
        this.rightSideFootClippingPlane.constant = value
        this.clippingSizes.leftSide = Math.abs(value)
        break;
      case clippingSides.back:
        this.heelClippingPlane.constant = value
        this.clippingSizes.heel = Math.abs(value)
        break;
      case clippingSides.front:
        this.fingersClippingPlane.constant = value
        this.clippingSizes.fingers = -Math.abs(value)
        break;
    }
  }

  deformMesh(value, clippingType: string) {

    switch (clippingType) {
      case "first":
        this.skeleton.bones[2].rotation.x = value / 100;
        break;
      case "second":
        this.skeleton.bones[2].rotation.z = value / 100;
        break;
      case "third":
        this.skeleton.bones[2].rotation.y = value / 100;
        break;
    }
  }

  reloadFile() {
    if (this.fileLoaded) {
      this.load3DFile(this.fileLoaded);
    }
  }

  saveFile() {

    if (!this.cropped) {
      Swal.fire({
        title: '你确定吗？',
        text: "您的模型没有被裁剪！",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '是的，无需裁剪即可保存！',
        cancelButtonText: this.translateService.instant('CANCEL')
      }).then((result) => {
        if (result.isConfirmed) {
          this.save3DFile();
        }
      })
    } else {
      this.save3DFile();
    }

  }

  async save3DFile() {
    if (!this.mesh || !this.fileLoaded) {
      Swal.fire('错误', '未加载3D模型', 'error');
      return;
    }

    // Crear una instancia del exportador en función del tipo de archivo
    let blob: Blob;

    if (this.fileLoaded.type === 'stl') {
      const exporter = new STLExporter();
      const stlString = exporter.parse(this.mesh, { binary: true });
      blob = new Blob([stlString], { type: 'model/stl' });
    } else if (this.fileLoaded.type === 'ply') {
      const exporter = new PLYExporter();
      const plyString = await new Promise<string>((resolve) => {
        exporter.parse(this.mesh, (result: string) => {
          resolve(result);
        }, { binary: true });
      });
      blob = new Blob([plyString], { type: 'text/plain' });
    } else if (this.fileLoaded.type === 'obj') {
      const exporter = new OBJExporter();
      const objString = exporter.parse(this.mesh); // OBJ normalmente es texto
      blob = new Blob([objString], { type: 'model/obj' });
    } else {
      Swal.fire('错误', '不支持的文件类型。仅允许 STL、PLY 和 OBJ。', 'error');
      return;
    }

    // Preparar los datos para la subida
    const formData = new FormData();
    formData.append(this.fileLoaded.name, blob);

    Swal.fire({
      title: '请稍等',
      html: `
            <div>上传3D模型</div><br>
            <div style="position: relative; width: 100%; height: 20px; background: #eee; border-radius: 10px;">
              <div id="swal-progressbar" style="height: 100%; background: #007bff; width: 0%; border-radius: 10px;"></div>
            </div>
      `,
      allowOutsideClick: false,
      showConfirmButton: false,
      allowEscapeKey: false,

    });

    try {

      // Obtener URI firmada para subir el archivo
      const signedUriData = await this.scanService.uploadSignedUri(this.scanId, this.fileLoaded.name).toPromise();

      // Subir el archivo a la URI firmada (El Content-Type va incluido en el blob)
      this.scanService.uploadFileToSignedUriWithPogress(signedUriData.uri, blob).subscribe({
        next: (event) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            const percentDone = Math.round((event.loaded / event.total) * 100);
            document.getElementById('swal-progressbar').style.width = `${percentDone}%`;
          } else if (event.type === HttpEventType.Response) {
            Swal.fire({
              icon: 'success',
              title: '上传成功',
              showConfirmButton: false,
              timer: 1500
            });

            // Actualizar el estado del archivo cargado
            this.fileLoaded.paid = true;

            // También actualizar el archivo en el array files para que el botón Start Design se habilite
            const fileIndex = this.files.findIndex(file => file.name === this.fileLoaded.name);
            if (fileIndex !== -1) {
              this.files[fileIndex].paid = true;
            }

            // Forzar actualización de la UI para que el botón Start Design se habilite inmediatamente
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          Swal.fire({
            icon: 'error',
            title: `上传错误: ${err}`,
            showConfirmButton: false,
            timer: 1500
          });
        }
      });

      // (Funciona, falta plantearlo mejor, mirar de configurarlo en el usuario)
      // // Encontrar el índice del archivo seleccionado para seleccionar automáticamente el siguiente archivo, si existe
      // const currentIndex = this.files.findIndex(file => file.name === this.selectedFile);

      // // Seleccionar automáticamente el siguiente archivo, si existe
      // if (currentIndex >= 0 && currentIndex < this.files.length - 1) {
      //     const nextFileName = this.files[currentIndex + 1].name;
      //     this.onFileSelectedChange(nextFileName); // Reutilizar lógica de selección
      // } else {
      //     console.log('No more files to select.');
      //     Swal.fire('All Files Processed', 'There are no more files to process.', 'info');
      // }

    } catch (err) {
      console.error(err);
      Swal.fire('错误', err.error?.message || '上传3D模型时出错', 'error');
    }
  }

  updateCanGoBack() {
    this.canGoBack = window.history.length > 1;
  }

  backButton() {
    this.location.back();
  }

  directionalLight() {

    const intensity = 0.3;
    const color = 0xffffff;

    const directionalLightTop = new THREE.DirectionalLight(color, intensity);
    directionalLightTop.name = 'light';
    directionalLightTop.position.set(0, 1, 0);
    const directionalLightBottom = new THREE.DirectionalLight(color, intensity);
    directionalLightBottom.name = 'light';
    directionalLightBottom.position.set(0, -1, 0);

    const directionalLightOver = new THREE.DirectionalLight(color, intensity);
    directionalLightOver.name = 'light';
    directionalLightOver.position.set(0, 0, 1);
    const directionalLightUnder = new THREE.DirectionalLight(color, intensity);
    directionalLightUnder.name = 'light';
    directionalLightUnder.position.set(0, 0, -1);

    const directionalLightLeft = new THREE.DirectionalLight(color, intensity);
    directionalLightLeft.name = 'light';
    directionalLightLeft.position.set(-1, 0, 0);
    const directionalLightRight = new THREE.DirectionalLight(color, intensity);
    directionalLightRight.name = 'light';
    directionalLightRight.position.set(1, 0, 0);

    this.scene.add(directionalLightUnder);
    this.scene.add(directionalLightOver);
    this.scene.add(directionalLightBottom);
    this.scene.add(directionalLightTop);
    this.scene.add(directionalLightLeft);
    this.scene.add(directionalLightRight);
  }


  initCutPlanes() {
    const geometry = this.mesh.geometry as THREE.BufferGeometry;
    const positions: Float32Array = geometry.attributes.position.array as Float32Array;
    const uvs: Float32Array = geometry.attributes.uv?.array as Float32Array;

    let newPositions = [];
    let newUVs = [];

    const total = positions.length;

    for (let i = 0; i < total; i += 9) { // 3 vertices por triángulo => 3*3 = 9 floats
      let x1 = positions[i], y1 = positions[i + 1], z1 = positions[i + 2];
      let x2 = positions[i + 3], y2 = positions[i + 4], z2 = positions[i + 5];
      let x3 = positions[i + 6], y3 = positions[i + 7], z3 = positions[i + 8];

      if (
        z1 >= this.clippingSizes.over || z1 <= this.clippingSizes.under ||
        z2 >= this.clippingSizes.over || z2 <= this.clippingSizes.under ||
        z3 >= this.clippingSizes.over || z3 <= this.clippingSizes.under ||
        y1 <= this.clippingSizes.rightSide || y1 >= this.clippingSizes.leftSide ||
        y2 <= this.clippingSizes.rightSide || y2 >= this.clippingSizes.leftSide ||
        y3 <= this.clippingSizes.rightSide || y3 >= this.clippingSizes.leftSide ||
        x1 <= this.clippingSizes.fingers || x1 >= this.clippingSizes.heel ||
        x2 <= this.clippingSizes.fingers || x2 >= this.clippingSizes.heel ||
        x3 <= this.clippingSizes.fingers || x3 >= this.clippingSizes.heel
      ) {
        continue; // Skip this triangle
      }

      // Keep positions
      newPositions.push(x1, y1, z1, x2, y2, z2, x3, y3, z3);

      // Keep UVs if available
      if (uvs) {
        const uvIndex = (i / 3) * 2; // Cada vértice tiene 2 UV floats
        newUVs.push(
          uvs[uvIndex], uvs[uvIndex + 1],
          uvs[uvIndex + 2], uvs[uvIndex + 3],
          uvs[uvIndex + 4], uvs[uvIndex + 5]
        );
      }
    }

    // Reasignar la geometría
    geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(newPositions), 3));

    if (uvs && newUVs.length > 0) {
      geometry.setAttribute('uv', new THREE.BufferAttribute(new Float32Array(newUVs), 2));
    }

    geometry.attributes.position.needsUpdate = true;
    if (geometry.attributes.uv) geometry.attributes.uv.needsUpdate = true;

    geometry.computeVertexNormals();
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();

    this.cropped = true;
    Swal.fire({
      icon: 'success',
      title: '模型裁剪成功',
      showConfirmButton: false,
      timer: 1500
    });
  }

  initClippingPlanes() {

    this.heightClippingPlane = new THREE.Plane(new THREE.Vector3(0, 0, -1), this.clippingSizes.over);
    this.fingersClippingPlane = new THREE.Plane(new THREE.Vector3(1, 0, 0), Math.abs(this.clippingSizes.fingers));
    this.heelClippingPlane = new THREE.Plane(new THREE.Vector3(-1, 0, 0), this.clippingSizes.heel);
    this.underFootClippingPlane = new THREE.Plane(new THREE.Vector3(0, 0, 1), Math.abs(this.clippingSizes.under));
    this.leftSideFootClippingPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), this.clippingSizes.leftSide);
    this.rightSideFootClippingPlane = new THREE.Plane(new THREE.Vector3(0, -1, 0), Math.abs(this.clippingSizes.rightSide));

    this.clippingPlanes = [
      this.heightClippingPlane,
      this.fingersClippingPlane,
      this.heelClippingPlane,
      this.underFootClippingPlane,
      this.leftSideFootClippingPlane,
      this.rightSideFootClippingPlane
    ];
  }


  ngAfterViewInit() {

    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setClearColor(0xffffff, 1);
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.BasicShadowMap;
    this.rendererContainer.nativeElement.appendChild(this.renderer.domElement);

    this.renderer.localClippingEnabled = false;

    this.animate();
    this.initializeStepper();
  }


  toggleClipping() {
    this.renderer.localClippingEnabled = this.renderer.localClippingEnabled ? false : true
  }


  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  applyVertexColors(mesh) {
    const geometry = mesh.geometry.clone();
    const material = mesh.material;

    const position = geometry.attributes.position;
    const uv = geometry.attributes.uv;
    const colors = [];

    const canvas = document.createElement('canvas');
    canvas.width = material.map.image.width;
    canvas.height = material.map.image.height;
    const context = canvas.getContext('2d');
    context.drawImage(material.map.image, 0, 0);

    const imgData = context.getImageData(0, 0, canvas.width, canvas.height).data;

    for (let i = 0; i < uv.count; i++) {
      const u = uv.getX(i);
      const v = uv.getY(i);
      const x = Math.floor(u * canvas.width);
      const y = Math.floor((1 - v) * canvas.height); // invertido Y

      const index = (y * canvas.width + x) * 4;

      const r = imgData[index] / 255;
      const g = imgData[index + 1] / 255;
      const b = imgData[index + 2] / 255;

      colors.push(r, g, b);
    }

    geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    mesh.geometry = geometry;
    mesh.material.vertexColors = true;

    return mesh;
  }

  processMeshWithColor(mesh) {
    const coloredMesh = this.applyVertexColors(mesh);

    // Exportar como PLY con colores por vértice
    const exporter = new PLYExporter();
    exporter.parse(coloredMesh, (result) => {
      const blob = new Blob([result], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const nameWithoutExtension = this.fileLoaded.name.replace(/\.[^/.]+$/, '');
      link.download = `${nameWithoutExtension}.ply`;
      link.click();
    }, { binary: false }); // o true para binario
  }

  exportPLY() {
    const mesh = this.mesh;
    if (!mesh || !mesh.material || !mesh.material.map) {
      console.error('No hay malla o textura para exportar');
      return;
    }

    const texture = mesh.material.map;
    const image = texture.image;

    if (!image || !image.complete) {
      console.warn('La textura aún no está completamente cargada');
      image.onload = () => this.exportPLY();
      return;
    }

    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context.drawImage(image, 0, 0);
    const imgData = context.getImageData(0, 0, canvas.width, canvas.height).data;

    const geometry = mesh.geometry.clone();
    const uv = geometry.attributes.uv;
    const colors = [];

    for (let i = 0; i < uv.count; i++) {
      const u = uv.getX(i);
      const v = uv.getY(i);
      const x = Math.floor(u * canvas.width);
      const y = Math.floor((1 - v) * canvas.height);
      const index = (y * canvas.width + x) * 4;

      const r = imgData[index] / 255;
      const g = imgData[index + 1] / 255;
      const b = imgData[index + 2] / 255;

      colors.push(r, g, b);
    }

    geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
    mesh.geometry = geometry;
    mesh.material.vertexColors = true;

    const exporter = new PLYExporter();
    exporter.parse(
      mesh,
      (result) => {
        const blob = new Blob([result], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        const nameWithoutExtension = this.fileLoaded.name.replace(/\.[^/.]+$/, '');
        link.download = `${nameWithoutExtension}.ply`;
        link.click();
      },
      { binary: true }
    );
  }

  load3DFile(file: ScanFile) {
    console.log("Find to find", file);
    // Remove all children
    while (this.scene.children.length > 0) {
      this.scene.remove(this.scene.children[0]);
    }

    // Floor plane
    this.addFloorPlane();

    // Reset align
    this.aligningPoints = [];
    this.textInfoAligning = '';
    this.aligning = false;
    this.aligned = false;
    this.cropped = false;
    this.textureLoaded = false;

    this.scanService.getFile(this.scanId, file.name).subscribe((data) => {
      if (!data || !data.uri) {
        Swal.fire('错误', '无效的文件数据或URI', 'error');
        return;
      }

      this.fileLoaded = file;

      let loader: STLLoader | PLYLoader | OBJLoader;

      if (file.type === 'stl') {
        loader = new STLLoader();
      } else if (file.type === 'ply') {
        loader = new PLYLoader();
      } else if (file.type === 'obj') {
        loader = new OBJLoader();
      } else {
        Swal.fire('3D文件', '仅可加载 STL、PLY 和 OBJ 文件', 'warning');
        return;
      }

      Swal.fire({
        title: '请稍等',
        html: `
              <div>上传3D模型</div><br>
              <div style="position: relative; width: 100%; height: 20px; background: #eee; border-radius: 10px;">
                <div id="swal-progressbar" style="height: 100%; background: #007bff; width: 0%; border-radius: 10px;"></div>
              </div>

        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        allowEscapeKey: false,
      });

      loader.load(data.uri, (object) => {
        if (file.type === 'obj') {
          let material = new THREE.MeshPhongMaterial({
            color: 0xF1C27D,
            transparent: false,
            side: THREE.DoubleSide,
            clippingPlanes: this.clippingPlanes,
            flatShading: false,
          });

          // Find if has texture file
          let fileWithoutExtension = file.name.split('.')[0];
          let foundTexture = this.scanFiles.find((fileFound) => fileFound.name.includes(fileWithoutExtension) && fileFound.type == "jpg" && !fileFound.name.includes('preview'))

          if (foundTexture) {
            const texture = new THREE.TextureLoader().load(foundTexture.path);
            material = new THREE.MeshPhongMaterial({
              map: texture,
              transparent: false,
              side: THREE.DoubleSide,
              clippingPlanes: this.clippingPlanes,
              flatShading: false
            });
            this.textureLoaded = true;
          }

          object.traverse((child) => {
            if ((child as THREE.Mesh).isMesh) {
              this.mesh = child as THREE.Mesh;
              this.mesh.material = material
              this.mesh.receiveShadow = true;
              this.mesh.castShadow = true;
              this.mesh.name = 'loaded_file';
              this.mesh.matrixAutoUpdate = true;
              this.renderer.localClippingEnabled = false;
              this.scene.add(this.mesh);
            }
          });

          if (!this.mesh) {
            Swal.fire('错误', 'OBJ 文件中未找到网格', 'error');
            return;
          }

        } else {
          let material: THREE.Material;

          if (file.type === 'ply') {
            material = new THREE.MeshPhongMaterial({
              vertexColors: true,
              transparent: false,
              side: THREE.DoubleSide,
            });

          } else {
            material = new THREE.MeshPhongMaterial({
              color: 0xF1C27D,
              transparent: false,
              side: THREE.DoubleSide,
              clippingPlanes: this.clippingPlanes,
              flatShading: false,
            });
          }

          this.mesh = new THREE.Mesh(object, material);
          this.mesh.receiveShadow = true;
          this.mesh.castShadow = true;
          this.mesh.name = 'loaded_file';
          this.mesh.matrixAutoUpdate = true;
          this.renderer.localClippingEnabled = false;
          // Update shadows and reflections
          this.mesh.geometry.computeVertexNormals()
          this.scene.add(this.mesh);
        }

        // Setup controls and other settings
        this.control = new TransformControls(this.camera, this.renderer.domElement);
        this.control.setSpace('world');
        this.control.addEventListener('dragging-changed', (event) => {
          this.renderer.render(this.scene, this.camera);
          this.orbit.enabled = !event.value;
        });
        this.control.attach(this.mesh);

        // Get center of the mesh to apply to controls
        const box = new THREE.Box3().setFromObject(this.mesh);
        const center = new THREE.Vector3();
        box.getCenter(center);

        // Posicionar TransformControls en el centro del objeto
        this.control.position.copy(center);
        this.control.visible = false;
        this.control.enabled = false;

        this.scene.add(this.control);
        this.camera.lookAt(this.mesh.position);
        this.directionalLight();
        Swal.close();

        // Apply rotations if they have it
        if (this.rotationsAndTransformations)
          this.applyTransformations();
      }, (onprogress) => {
        const progress = (onprogress.loaded * 100 / onprogress.total).toFixed(2);
        document.getElementById('swal-progressbar').style.width = `${progress}%`;

      }, (err) => {
        console.log(err);
        Swal.fire('错误', '无法加载扫描数据', 'error');
      });
    }, (err) => {
      Swal.fire('错误', err.error.message, 'error');
    });


  }


  addFloorPlane() {
    // Floor plane
    var meshFloor = new THREE.Mesh(
      new THREE.PlaneGeometry(500, 250, 10, 10),
      new THREE.MeshBasicMaterial({ color: 0x000000, wireframe: false, side: THREE.DoubleSide, transparent: true, opacity: 0.3 })
    );
    meshFloor.name = 'floor_plane'
    this.scene.add(meshFloor);
  }

  autoLandMarks() {
    // Punto más bajo del objecto 
    const positions: Float32Array = (this.mesh.geometry as THREE.BufferGeometry).attributes.position.array as Float32Array
    var lowerPart: Vector3
    var higherPart: Vector3
    var firstMet: Vector3
    var fifthMeth: Vector3

    for (let i = 0; i < positions.length; i += 3) {
      let x = positions[i];
      let y = positions[i + 1];
      let z = positions[i + 2];

      if (z == 0) {
        // this.addLine(new THREE.Vector3(x, y,z), 0xbbbbbb)
        this.addPoint(new THREE.Vector3(x, y, z))

        //Max X boundingBox minut found minimum
        const boxTest = new THREE.Box3();
        boxTest.copy(this.mesh.geometry.boundingBox);
        var yyy = boxTest.max.y - y;
        var prueba = yyy / 10;


        this.addLine(new THREE.Vector3(x, (prueba + y), z), 0xbbbbbb)
        this.addLine(new THREE.Vector3(x, (prueba * 2) + y, z), 0xbbbbbb)
        this.addLine(new THREE.Vector3(x, (prueba * 3) + y, z), 0xbbbbbb)
        this.addLine(new THREE.Vector3(x, (prueba * 4) + y, z), 0xbbbbbb)
        this.addLine(new THREE.Vector3(x, (prueba * 5) + y, z), 0xbbbbbb)
        this.addLine(new THREE.Vector3(x, (prueba * 6) + y, z), 0xbbbbbb)
        lowerPart = new THREE.Vector3(x, (prueba * 6) + y, z);
        this.addLine(new THREE.Vector3(x, (prueba * 7) + y, z), 0xbbbbbb)
        higherPart = new THREE.Vector3(x, (prueba * 7) + y, z);
        break;
      }
    }

    var maxX = 0
    var minX = 99999
    var maxXVector: Vector3
    var minXVector: Vector3

    for (let i = 0; i < positions.length; i += 3) {
      let x = positions[i];
      let y = positions[i + 1];
      let z = positions[i + 2];

      if (x < (lowerPart.x - 30) && y > lowerPart.y && y < higherPart.y) {
        var vectorFound = new THREE.Vector3(x, y, z);
        var referenceVector = new THREE.Vector3(x, y, 0)

        if (x < minX) {
          minX = x
          minXVector = new THREE.Vector3(x, y, z);
        }
      }

      if (x > (lowerPart.x + 30) && y > lowerPart.y && y < higherPart.y) {
        var vectorFound = new THREE.Vector3(x, y, z);
        var referenceVector = new THREE.Vector3(x, y, 0)

        if (x > maxX) {
          maxX = x
          maxXVector = new THREE.Vector3(x, y, z);
        }
      }
    }

    var distToZ = 999999999;
    var distToZ2 = 999999999;
    for (let i = 0; i < positions.length; i += 3) {
      let x = positions[i];
      let y = positions[i + 1];
      let z = positions[i + 2];

      let rest = y - maxXVector.y;

      if (y == maxXVector.y || y > maxXVector.y && rest < 1 && x > (maxXVector.x - 30)) {
        var actualP = new THREE.Vector3(x, y, z);
        var vectorFound = new THREE.Vector3(x, y, z);
        var referenceVector = new THREE.Vector3(x, y, 0)

        var distance = vectorFound.distanceTo(referenceVector)
        if (distance < distToZ) {
          distToZ = distance;
          fifthMeth = vectorFound;
        }
      }


      let rest2 = y - minXVector.y;

      if (y == minXVector.y || y > minXVector.y && rest2 < 1 && x < (minXVector.x + 30)) {
        var actualP = new THREE.Vector3(x, y, z);
        var vectorFound = new THREE.Vector3(x, y, z);
        var referenceVector = new THREE.Vector3(x, y, 0)

        var distance = vectorFound.distanceTo(referenceVector)
        if (distance < distToZ2) {
          distToZ2 = distance;
          firstMet = vectorFound;
        }

      }
    }

    this.addPoint(firstMet)
    this.addPoint(fifthMeth)
  }


  addPoint(vector3: Vector3) {
    var geometry = new THREE.SphereGeometry(3, 10, 10);
    var material = new THREE.MeshBasicMaterial({ color: 0x313131 });
    var sphere = new THREE.Mesh(geometry, material);
    sphere.position.copy(vector3);
    this.scene.add(sphere)
  }


  slineCurvesTwo() {
    const curve = new THREE.CatmullRomCurve3([
      new THREE.Vector3(220, this.mesh.geometry.boundingBox.max.y, 30),
      new THREE.Vector3(120, this.mesh.geometry.boundingBox.max.y, 50),
      new THREE.Vector3(30, this.mesh.geometry.boundingBox.max.y, 0)
    ]);

    const points = curve.getPoints(50);
    const geometry = new THREE.BufferGeometry().setFromPoints(points);

    const material = new THREE.LineBasicMaterial({ color: 0xff0000 });

    // Create the final object to add to the scene
    const curveObject = new THREE.Line(geometry, material);

    this.scene.add(curveObject);
  }


  factorCorte() {

    var material = new THREE.LineBasicMaterial({ color: 0xff0000, linewidth: 2 });
    const geometry = new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(50, 0, this.mesh.geometry.boundingBox.max.z), new THREE.Vector3(90, this.mesh.geometry.boundingBox.max.y, this.mesh.geometry.boundingBox.max.z)]);
    var line = new THREE.Line(geometry, material);

    this.scene.add(line);

  }


  corteTalon() {
    const curve = new THREE.CatmullRomCurve3([
      new THREE.Vector3(220, 0, this.mesh.geometry.boundingBox.max.z - 15),
      new THREE.Vector3(180, 0, this.mesh.geometry.boundingBox.max.z - 20),
      new THREE.Vector3(160, 0, 0)
    ]);

    const curve2 = new THREE.CatmullRomCurve3([
      new THREE.Vector3(220, 0, this.mesh.geometry.boundingBox.max.z),
      new THREE.Vector3(180, 0, this.mesh.geometry.boundingBox.max.z - 10),
      new THREE.Vector3(150, 0, 0)
    ]);

    const points = curve.getPoints(50);
    const points2 = curve2.getPoints(50);

    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    const geometry2 = new THREE.BufferGeometry().setFromPoints(points2);

    const material = new THREE.LineBasicMaterial({ color: 0xff0000 });

    // Create the final object to add to the scene
    const curveObject = new THREE.Line(geometry, material);
    const curveObject2 = new THREE.Line(geometry2, material);

    this.scene.add(curveObject);
    this.scene.add(curveObject2);
  }


  updateBoundingBox() {
    this.boundingBox.update();
  }


  animate() {
    window.requestAnimationFrame(() => this.animate());

    // clock

    if (this.helper.animating) this.helper.update(this.clock.getDelta());

    this.renderer.clear();
    this.renderer.render(this.scene, this.camera);
    this.helper.render(this.renderer)

    if (this.compose) {
      this.compose.render()
      this.renderer.render(this.sceneLinesHelper, this.camera);
    }
  }

  onFileSelectedChange(filename: string) {
    this.selectedFile = filename;

    // Buscar en las listas de archivos STL y PLY
    let file: ScanFile | undefined;
    file = this.files.find((file: ScanFile) => file.name === filename)

    // Si no se encuentra el archivo, muestra un mensaje de advertencia y detén la ejecución
    if (!file) {
      Swal.fire('文件未找到', '未找到所选文件。', 'error');
      return;
    }

    if (file.paid) {
      this.allStepsCompleted = true;
    } else {
      this.allStepsCompleted = false;
    }

    this.updateIndividualSteps(file);

    this.checkFileForLandmarksAndSetStepper(file);

    // Verificar el tipo de archivo y cargar si es compatible
    if (file.type === "stl" || file.type === "ply" || file.type === 'obj') {
      this.load3DFile(file);
    } else {
      Swal.fire('3D文件', '仅可加载 STL、PLY 和 OBJ 文件', 'warning');
    }
  }

  updateIndividualSteps(currentFile?: any) {
    // Usar el archivo actual si se proporciona, sino usar this.fileLoaded
    const fileToCheck = currentFile || this.fileLoaded;
    const shouldBeCompleted = this.allStepsCompleted || (fileToCheck && fileToCheck.paid);

    this.step1Completed = shouldBeCompleted;
    this.step2Completed = shouldBeCompleted;
    this.step3Completed = shouldBeCompleted;
  }

  // processFile(file: ScanFile) {

  //   // Connect websocket
  //   // this.websocketService.subject.unsubscribe()
  //   Swal.fire("Requesting postprocessing", "Please wait...", "info")

  //   this.websocketService.subject.subscribe(
  //     msg => {
  //       let response = JSON.stringify(msg);
  //       let parsed = JSON.parse(response);
  //       let splittedFilename = this.fileLoaded.name.replace("_processed", "");

  //       console.log('message received: ' + response)
  //       if (parsed.fileName == splittedFilename) {
  //         Swal.update({
  //           icon: "info",
  //           title: parsed.status,
  //           html: '<div>Please wait (~ 10s to 1min)</div><br>'
  //         })
  //         Swal.showLoading()
  //         if (parsed.status == "success") {
  //           Swal.update({
  //             icon: "success",
  //             html: "All the steps completed!",
  //             allowOutsideClick: true,
  //             showConfirmButton: true,
  //             allowEscapeKey: true,
  //             confirmButtonText: "Reload",
  //             didClose: () => {
  //               this.reloadFile()
  //             }
  //           })
  //           Swal.hideLoading()

  //         }
  //       }

  //     }, // Called whenever there is a message from the server.
  //     err => console.log("error receiving" + err), // Called if at any point WebSocket API signals some kind of error.
  //     () => console.log('complete') // Called when connection is closed (for whatever reason).
  //   );
  //   this.websocketService.createScanIdConnection(this.scanId)

  //   if (!file.paid) {

  //     var splittedPath = file.path.split('/')
  //     var splittedName = splittedPath[5].split(".")
  //     var finalName = splittedName[0].replace('_processed', '');
  //     var plyFile = `${finalName}.ply`

  //     // this.websocketService.createScanIdConnection(splittedPath[4]);

  //     var path = `${splittedPath[3]}/${splittedPath[4]}/${plyFile}`

  //     var body = {
  //       path,
  //       closeHoles: this.postProcessing.fillHoles,
  //       reconstructionDepth: this.postProcessing.reconstructionDepth,
  //       removeSmallParts: this.postProcessing.removeSmallParts,
  //       mergeCloseVertices: this.postProcessing.mergeCloseVertices,
  //       smooth: this.postProcessing.smooth,
  //       smoothSteps: this.postProcessing.smoothSteps
  //     }

  //     this.postProcessService.process(body).subscribe(() => {
  //       // this.reloadFile()
  //     }, () => {
  //       // Swal.fire("Failed!", "error processing", "error")
  //     })
  //   } else {
  //     Swal.fire({
  //       title: 'No valid file!',
  //       html: '<div>Cannot process an already paid file</div><br>',
  //       icon: "error"
  //     });
  //   }


  // }


  ngOnInit(): void {
    this.connectSocket()
  }


  createAlignmentPoints(event: MouseEvent | TouchEvent) {

    let mouse = new THREE.Vector2();

    const divRender = document.getElementById('render')
    const offsetLeft = divRender.getBoundingClientRect().left

    if (event instanceof MouseEvent) {
      mouse.x = ((event.clientX - offsetLeft) / this.renderer.domElement.width) * 2 - 1;
      mouse.y = - ((event.clientY - this.renderer.domElement.offsetTop) / this.renderer.domElement.height) * 2 + 1;
    } else if (event instanceof TouchEvent) {
      mouse.x = ((event.targetTouches[0].clientX - offsetLeft) / this.renderer.domElement.width) * 2 - 1;
      mouse.y = - ((event.targetTouches[0].clientY - this.renderer.domElement.offsetTop) / this.renderer.domElement.height) * 2 + 1;
    }

    let raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, this.camera);

    // calculate objects intersecting the picking ray
    const intersects = raycaster.intersectObjects(this.scene.children, true);


    if (this.aligning) {

      if (intersects.length > 0) {
        // If found first intersected it will be false, to avoid create double points on the same object
        let foundFirstPoint = false;
        intersects.map((intersected) => {
          if (intersected.object.name == 'loaded_file' && !foundFirstPoint && this.aligningPoints.length < 3) {
            foundFirstPoint = true;
            var geometry = new THREE.SphereGeometry(4, 10, 10);
            var material = new THREE.MeshBasicMaterial({ color: 0x313131 });
            var sphere = new THREE.Mesh(geometry, material);

            sphere.name = 'point ' + this.aligningPoints.length;
            sphere.position.set(0, 0, 0);
            sphere.lookAt(intersected.face.normal);
            const localPosition = this.mesh.worldToLocal(intersected.point.clone());
            sphere.position.copy(localPosition);

            this.mesh.add(sphere);

            console.log(sphere.position);
            this.addAlignmentPoint(sphere.position);

          }
        })
      }
    }

    if (this.addingCircles) {

      if (intersects.length > 0) {
        // If found first intersected it will be false, to avoid create double points on the same object
        let foundFirstPoint = false;
        intersects.map((intersected) => {
          console.log("INTERSECTED ADD IT!")
          if (intersected.object.name == 'loaded_file' && !foundFirstPoint && this.aligningPoints.length < 3) {
            foundFirstPoint = true;

            this.addCircle(intersected.point.x, intersected.point.y, -5);
          }
        })
      }
    }

    if (this.cropping) {

    }
  }

  showObjectsBeforeAdd(event: MouseEvent) {
    let mouse = new THREE.Vector2();

    const divRender = document.getElementById('render')
    const offsetLeft = divRender.getBoundingClientRect().left

    mouse.x = ((event.clientX - offsetLeft) / this.renderer.domElement.width) * 2 - 1;
    mouse.y = - ((event.clientY - this.renderer.domElement.offsetTop) / this.renderer.domElement.height) * 2 + 1;

    let raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, this.camera);

    // calculate objects intersecting the picking ray
    const intersects = raycaster.intersectObjects(this.scene.children, true);

    if (this.addingCircles) {

      if (intersects.length > 0) {
        // If found first intersected it will be false, to avoid create double points on the same object
        let foundFirstPoint = false;
        intersects.map((intersected) => {

          if (intersected.object.name == 'loaded_file' && !foundFirstPoint && this.aligningPoints.length < 3) {
            foundFirstPoint = true;

            this.circleToMove.position.set(0, 0, 0);
            this.circleToMove.position.copy(new THREE.Vector3(intersected.point.x, intersected.point.y, -10));

          }
        })
      }
    }
  }

  align() {

    let subvector1 = new THREE.Vector3();
    let subvector2 = new THREE.Vector3();
    let crossVectors = new THREE.Vector3();

    // Create the cross vector with the 3 points
    subvector1.subVectors(this.aligningPoints[0], this.aligningPoints[2]);
    subvector2.subVectors(this.aligningPoints[0], this.aligningPoints[1]);
    crossVectors.crossVectors(subvector1, subvector2);

    // Move the mesh (0,0,0) plane
    this.mesh.geometry.applyMatrix4(new Matrix4().makeTranslation(-this.aligningPoints[0].x, -this.aligningPoints[0].y, -this.aligningPoints[0].z))

    // Align the mesh to the plane with quaternion and matrix4
    const quaternion = new THREE.Quaternion();
    quaternion.setFromUnitVectors(crossVectors.normalize(), new THREE.Vector3(0, 0, 1).normalize());
    let matrix4 = new THREE.Matrix4()
    matrix4.makeRotationFromQuaternion(quaternion);
    this.mesh.geometry.applyMatrix4(matrix4);

    // Move all the points
    let xToRest = -this.aligningPoints[0].x;
    let yToRest = -this.aligningPoints[0].y;
    let zToRest = -this.aligningPoints[0].z;

    this.mesh.children.map((pointToAlign) => {
      pointToAlign.applyMatrix4(new Matrix4().makeTranslation(xToRest, yToRest, zToRest))
      pointToAlign.applyMatrix4(matrix4);
    })


    // The the middle point of the (first and fifth) methatarsal points
    let puntoMedioX = (this.mesh.children[1].position.x + this.mesh.children[2].position.x) / 2;
    let puntoMedioY = (this.mesh.children[1].position.y + this.mesh.children[2].position.y) / 2;

    let middlePointBetweenMets = new THREE.Vector3(puntoMedioX, puntoMedioY, 0);

    // Align the mesh to the plane with quaternion and matrix4
    const quaternion2 = new THREE.Quaternion();
    quaternion2.setFromUnitVectors(middlePointBetweenMets.normalize(), new THREE.Vector3(-1, 0, 0).normalize());
    let matrix42 = new THREE.Matrix4()
    matrix42.makeRotationFromQuaternion(quaternion2);
    this.mesh.geometry.applyMatrix4(matrix42);

    this.mesh.children.map((pointToAlign) => {
      pointToAlign.applyMatrix4(matrix42);
    })

    // Obtener la cantidad de vértices de la geometría del objeto
    const vertexCount = this.mesh.geometry.attributes.position.count;

    // Contar la cantidad de vértices en la zona que es menor de cero en el eje Z
    let zCount = 0;
    for (let i = 0; i < vertexCount; i++) {
      const zValue = this.mesh.geometry.attributes.position.getZ(i);
      if (zValue < 0) {
        zCount++;
      }
    }

    // Verificar si la mayoría de los vértices están en la zona que es menor de cero en el eje Z
    if (zCount > vertexCount / 2) {
      // Girar el objeto en 180 grados alrededor del eje X
      this.rotate180();
    }

    // Remove the aligning points
    this.removeAligningPoints();

  }


  prepareForDesign() {
    const boxTest = new THREE.Box3();
    boxTest.copy(this.mesh.geometry.boundingBox);
    this.mesh.geometry.applyMatrix4(new Matrix4().makeTranslation(-boxTest.min.x, -boxTest.min.y, -boxTest.min.z))
  }


  axisShow() {
    this.addLine(new THREE.Vector3(1000, 0, 0), 0xbbbbbb);
    this.addLine(new THREE.Vector3(0, 1000, 0), 0xbbbbbb);
  }


  addLine(destination: THREE.Vector3, color, origin?: THREE.Vector3, extend?: boolean, addLength?: boolean, rotationInDegrees?: number) {

    var material = new THREE.MeshBasicMaterial({ color: color }); // Cambio del material a MeshBasicMaterial
    const geometry = new THREE.BufferGeometry().setFromPoints([origin ? origin : new THREE.Vector3(), destination]);
    var line = new THREE.LineSegments(geometry, material); // Cambio de Line a LineSegments


    if (extend) {
      // Escalar el vector que conecta los dos puntos por un factor de 3 para extender la línea en ambos sentidos
      const extensionVector = origin.clone().sub(destination).multiplyScalar(1);

      // Agregar el vector escalado a ambos puntos para obtener los nuevos puntos extendidos
      const extendedOrigin = origin.clone().add(extensionVector);
      const extendedDestination = destination.clone().sub(extensionVector);

      // Crear un Float32Array que contenga las coordenadas de los dos puntos originales y los puntos extendidos
      const positions = new Float32Array([
        destination.x, destination.y, destination.z,
        origin.x, origin.y, origin.z,
        extendedOrigin.x, extendedOrigin.y, extendedOrigin.z,
        extendedDestination.x, extendedDestination.y, extendedDestination.z,
      ]);

      // Crear un BufferAttribute con las coordenadas
      const positionAttribute = new THREE.BufferAttribute(positions, 3);

      // Crear una BufferGeometry y agregar el BufferAttribute como un atributo de posición
      const geometry = new THREE.BufferGeometry();
      geometry.setAttribute('position', positionAttribute);

      // Crear un material y una Mesh con la BufferGeometry
      line = new THREE.LineSegments(geometry, material); // Cambio de Line a LineSegments
    }

    // añadir el texto de la longitud de la línea
    if (addLength && origin) {
      const midpoint = new THREE.Vector3();
      midpoint.addVectors(origin, destination).multiplyScalar(0.80);

      let distance = origin.distanceTo(destination);

      this.addText(midpoint.x, midpoint.y, midpoint.z, distance.toFixed(2).toString())
    }

    if (rotationInDegrees) {
      const pivot = destination;
      const rotationMatrix = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 0, 1), rotationInDegrees); // matriz de rotación alrededor del eje Z
      line.geometry.applyMatrix4(new THREE.Matrix4().makeTranslation(-pivot.x, -pivot.y, -pivot.z)); // trasladar la línea al origen
      line.geometry.applyMatrix4(rotationMatrix); // aplicar la rotación a la geometría de la línea
      line.geometry.applyMatrix4(new THREE.Matrix4().makeTranslation(pivot.x, pivot.y, pivot.z)); // trasladar la línea de vuelta a su posición original
    }

    line.name = "measurement_line"
    this.sceneLinesHelper.add(line);
  }


  cutPlane() {
    // Crear un objeto de tipo THREE.Plane para definir el plano de referencia
    const plane = new THREE.Plane();
    const planeNormal = new THREE.Vector3(0, 0, -1);
    const planeHelper = new THREE.PlaneHelper(plane, 100, 0xff0000);
    this.scene.add(planeHelper);

  }


  addAlignmentPoint(position: THREE.Vector3) {
    this.aligningPoints.push(position);

    if (this.aligningPoints.length == 1) {
      this.nextPointToSelectForAlignment = '1st Met'
    } else if (this.aligningPoints.length == 2) {
      this.nextPointToSelectForAlignment = '5ft Met'
    } else {
      this.align();
    }
  }


  addCircle(x, y, z) {
    const geometry = new THREE.CircleGeometry(5, 32);
    const material = new THREE.MeshBasicMaterial({ color: 0xffff00, side: THREE.DoubleSide });
    const circle = new THREE.Mesh(geometry, material);

    circle.position.set(x, y, z)

    this.scene.add(circle);
  }


  addText(x, y, z, text) {
    const fontJson = textFont;
    const loader = new FontLoader();

    const font = loader.load(
      // resource URL
      "assets/fonts/gentilis_bold.typeface.json",

      // onLoad callback
      (font) => {

        const message = text + "mm";
        const textGeometry = new TextGeometry(message, {
          height: 2,
          size: 10,
          font
        })

        const material = new THREE.MeshBasicMaterial();
        const textMesh = new THREE.Mesh(textGeometry, material);

        textMesh.position.set(x - 4, y + 4, z);
        textMesh.name = "measurement";
        // textMesh.geometry.rotateX(-Math.PI);
        this.scene.add(textMesh);

      },

      // onProgress callback
      function (xhr) {
      },

      // onError callback
      function (err) {
        console.log(err)
        console.log('An error happened');
      }
    );
  }


  addSline(x, y, z) {
    const curve = new THREE.CatmullRomCurve3([
      new THREE.Vector3(220, 0, 30),
      new THREE.Vector3(120, 0, 50),
      new THREE.Vector3(30, 0, 0)
    ]);

    const points = curve.getPoints(50);
    const geometry = new THREE.BufferGeometry().setFromPoints(points);

    const material = new THREE.LineBasicMaterial({ color: 0xff0000 });

    // Create the final object to add to the scene
    const curveObject = new THREE.Line(geometry, material);

    this.scene.add(curveObject);
  }


  removeAligningPoints() {
    this.mesh.children = [];
    //this.aligningPoints = [];
    this.textInfoAligning = '';
    this.aligning = false;
  }

  rotate180() {
    // Obtener la matriz de rotación para girar la geometría 180 grados
    const rotateMatrix = new THREE.Matrix4().makeRotationX(-Math.PI);

    // Aplicar la rotación a la geometría de la malla
    this.mesh.geometry.applyMatrix4(rotateMatrix);

    // Iterar sobre los children de la malla y aplicar la misma rotación a su posición
    this.mesh.children.forEach(child => {
      // Obtener la posición del child en relación a la posición original de la malla
      const originalPosition = child.position.clone().applyMatrix4(this.mesh.matrixWorld);

      // Aplicar la rotación a la posición del child
      originalPosition.applyMatrix4(rotateMatrix);

      // Mover el child a la nueva posición
      child.position.copy(originalPosition);
    });

  }


  invertScan() {
    this.mesh.geometry.scale(1, -1, 1);
  }

  async refund(filePath: string) {
    const { value: text } = await Swal.fire({
      input: 'textarea',
      inputLabel: '评论',
      inputPlaceholder: '请在此处输入您的留言……',
      inputAttributes: {
        'aria-label': '请在此处输入您的留言'
      },
      showCancelButton: true,
      cancelButtonText: this.translateService.instant('CANCEL')
    })

    if (text) {

      Swal.fire({
        title: '请稍等',
        html: '创建退款请求',
        allowOutsideClick: false,
        showConfirmButton: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });

      this.refundService.create(this.scanId, filePath, text).subscribe((refund) => {
        Swal.fire({
          title: '对基本 STL 进行网格划分',
          html: '请稍等片刻，待我们处理完毕后，您可以手动对齐。',
          allowOutsideClick: false,
          showConfirmButton: false,
          allowEscapeKey: false,
          willOpen: () => {
            Swal.showLoading();
          }
        });
        // Process again the STL with basic server(Meshlab)
        this.meshlabService.process(filePath).subscribe((result) => {
          Swal.fire({
            icon: 'success',
            title: '再次进行 3D 网格化',
            html: '您可以手动对齐文件并继续工作。',
            showConfirmButton: false,
            timer: 1500
          })
          this.loadFiles();
          // this.reloadFile();
        }, (err) => {
          Swal.fire('错误', '对基本 STL 进行网格划分时出现错误 ' + err.message, 'error');
        })
      }, (err) => {
        Swal.fire('错误', '创建退款请求时出现错误 ' + err.message, 'error');
      })
    }
  }

  //hemos definido una escala de colores que comienza con el rojo en el eje z y cambia gradualmente a verde, azul y púrpura a medida que la distancia al eje z aumenta. Hemos dividido la distancia al eje z en intervalos de 5 unidades y hemos ajustado los valores RGB de los colores en cada intervalo para crear la transición gradual de colores.
  //Este código se asegura de que el color de los objetos cambie gradualmente a medida que se acercan al eje z, con los objetos más cercanos al eje z tomando un tono más rojo, los objetos en el centro de la escena siendo más verdes, y los objetos más lejanos del eje z tomando un tono más azul o púrpura.
  ApplyColorDegradation() {
    const vertexShader = `
            varying vec3 vPosition;
    
            void main() {
                vPosition = position;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
            }
        `;


    // If colors "blue"
    let fragmentShader = `
            varying vec3 vPosition;
    
            void main() {
                float distance = abs(vPosition.z);
    
                vec3 baseColor = vec3(59.0 / 255.0, 92.0 / 255.0, 130.0 / 255.0);
    
                if (distance < 5.0) {
                    gl_FragColor = vec4(baseColor, 1.0);
                } else if (distance < 50.0) {
                    float t = (distance - 5.0) / 45.0;
                    t = pow(t, 0.5); // Ajustar la escala del degradado
                    gl_FragColor = vec4(mix(baseColor, vec3(1.0), t), 1.0);
                } else {
                    gl_FragColor = vec4(0.0, 0.0, 1.0, 1.0);
                }
            }
        `;

    // If colors "red_yellow_blue"
    if (this.savedColor == "red_yellow_blue") {
      fragmentShader = `
            varying vec3 vPosition;

            vec3 gradientColor(float distance) {
                vec3 startColor = vec3(1.0, 0.0, 0.0); // Rojo
                vec3 middleColor = vec3(1.0, 1.0, 0.0); // Amarillo
                vec3 endColor = vec3(0.5, 0.0, 0.5); // Púrpura

                float t;
                if (distance < 10.0) {
                    t = clamp(distance / 10.0, 0.0, 1.0);
                    return mix(startColor, middleColor, t);
                } else {
                    t = clamp((distance - 10.0) / 10.0, 0.0, 1.0);
                    return mix(middleColor, endColor, t);
                }
            }

            void main() {
                float distance = abs(vPosition.z);
                vec3 color = gradientColor(distance);
                gl_FragColor = vec4(color, 1.0);
            }
        `;
    }



    const material = new THREE.ShaderMaterial({
      vertexShader,
      fragmentShader,
      side: THREE.DoubleSide,
      clippingPlanes: this.clippingPlanes
    });

    this.mesh.material = material;
    this.mesh.geometry.computeVertexNormals();
  }


  createPlaneFromPlanarGeometry(planarGeometry) {
    let localPlane = new THREE.Plane();
    let normal = new THREE.Vector3();
    let point = new THREE.Vector3();

    normal.set(0, -1, 0).applyQuaternion(planarGeometry.quaternion);
    point.copy(planarGeometry.position);
    localPlane.setFromNormalAndCoplanarPoint(normal, point).normalize();

    return localPlane;
  }


  drawIntersectionLine() {

    // set points to 0
    this.ballCircumferencePoints = []
    this.instepCircumferencePoints = []
    this.longHeelCircumferencePoints = []
    this.shortHeelCircumferencePoints = []
    this.ankleCircumferencePoints = []
    this.testCircumferencePoints = []

    let lines = new THREE.LineSegments(
      new THREE.BufferGeometry(),
      new THREE.LineBasicMaterial({
        color: 0x000000,
        linewidth: 5
      })
    );

    this.scene.add(lines);

    let planeGeom = new THREE.PlaneGeometry(300, 200);
    planeGeom.rotateX(-Math.PI / 2);

    let plane = new THREE.Mesh(
      planeGeom,
      new THREE.MeshBasicMaterial({
        color: "lightgray",
        transparent: true,
        opacity: 0,
        side: THREE.FrontSide
      })
    );
    plane.position.x = -130;
    plane.rotateX(THREE.MathUtils.degToRad(90))
    plane.rotateZ(THREE.MathUtils.degToRad(90))
    plane.rotateOnAxis(new THREE.Vector3(1, 0, 0), THREE.MathUtils.degToRad(15))
    this.scene.add(plane);


    // Get the length of the foot
    let minMaxCoords = this.getMinumumAndMaximumXVectors();
    minMaxCoords.maxX.z = 55;
    minMaxCoords.minX.z = 55;

    this.createWideLine(minMaxCoords.minX, minMaxCoords.maxX, new THREE.Color(0x00FF00));
    // Obtener la dirección y la longitud de la línea
    const direccion = new THREE.Vector3().subVectors(minMaxCoords.minX, minMaxCoords.maxX);
    const longitud = direccion.length();

    // Obtener el punto a un tercio de la longitud de la línea
    const tercio = longitud * 0.50;
    const point50Percent = minMaxCoords.maxX.clone().add(direccion.normalize().multiplyScalar(tercio));

    let instepPlane = new THREE.Mesh(
      planeGeom,
      new THREE.MeshBasicMaterial({
        color: "lightgray",
        transparent: true,
        opacity: 0,
        side: THREE.FrontSide
      })
    );
    instepPlane.position.x = point50Percent.x;
    instepPlane.rotateX(THREE.MathUtils.degToRad(90))
    instepPlane.rotateZ(THREE.MathUtils.degToRad(90))
    this.scene.add(instepPlane);

    let longHeelPlane = new THREE.Mesh(
      planeGeom,
      new THREE.MeshBasicMaterial({
        color: "lightgray",
        transparent: true,
        opacity: 0,
        side: THREE.FrontSide
      })
    );
    longHeelPlane.position.x = 26.39;
    longHeelPlane.position.y = 1.95;
    longHeelPlane.position.z = 9.89;
    longHeelPlane.rotateX(THREE.MathUtils.degToRad(90))
    longHeelPlane.rotateZ(THREE.MathUtils.degToRad(-33))
    this.scene.add(longHeelPlane);

    let shortHeelPlane = new THREE.Mesh(
      planeGeom,
      new THREE.MeshBasicMaterial({
        color: "lightgray",
        transparent: true,
        opacity: 0,
        side: THREE.FrontSide
      })
    );
    shortHeelPlane.position.x = 26.39;
    shortHeelPlane.position.y = 1.95;
    shortHeelPlane.position.z = 9.89;
    shortHeelPlane.rotateX(THREE.MathUtils.degToRad(90))
    shortHeelPlane.rotateZ(THREE.MathUtils.degToRad(-45))
    this.scene.add(shortHeelPlane);


    let anklePlane = new THREE.Mesh(
      planeGeom,
      new THREE.MeshBasicMaterial({
        color: "lightgray",
        transparent: true,
        opacity: 0,
        side: THREE.FrontSide
      })
    );
    anklePlane.position.x = 50;
    anklePlane.position.z = 120;
    anklePlane.rotateX(THREE.MathUtils.degToRad(90))
    this.scene.add(anklePlane);


    let testPlane = new THREE.Mesh(
      planeGeom,
      new THREE.MeshBasicMaterial({
        color: "lightgray",
        transparent: true,
        opacity: 0.5,
        side: THREE.FrontSide
      })
    );
    testPlane.position.x = 0;
    testPlane.rotateX(THREE.MathUtils.degToRad(90))
    testPlane.rotateZ(THREE.MathUtils.degToRad(45))
    this.scene.add(testPlane);

    let a = new THREE.Vector3();
    let b = new THREE.Vector3();
    let c = new THREE.Vector3();

    this.mesh.traverse((obj) => {
      if (obj instanceof THREE.Mesh) {
        const isIndexed = obj.geometry.index != null;
        const pos = obj.geometry.attributes.position;
        const idx = obj.geometry.index;
        const faceCount = (isIndexed ? idx.count : pos.count) / 3;

        const instepClippingPlane = this.createPlaneFromPlanarGeometry(instepPlane);
        const clippingPlane = this.createPlaneFromPlanarGeometry(plane);
        const longHeelclippingPlane = this.createPlaneFromPlanarGeometry(longHeelPlane);
        const shortHeelclippingPlane = this.createPlaneFromPlanarGeometry(shortHeelPlane);
        const ankleclippingPlane = this.createPlaneFromPlanarGeometry(anklePlane);

        const testclippingPlane = this.createPlaneFromPlanarGeometry(testPlane);

        let positions = [];

        for (let i = 0; i < faceCount; i++) {
          let baseIdx = i * 3;
          let idxA = baseIdx + 0;
          a.fromBufferAttribute(pos, isIndexed ? idx.getX(idxA) : idxA);
          let idxB = baseIdx + 1;
          b.fromBufferAttribute(pos, isIndexed ? idx.getX(idxB) : idxB);
          let idxC = baseIdx + 2;
          c.fromBufferAttribute(pos, isIndexed ? idx.getX(idxC) : idxC);

          obj.localToWorld(a);
          obj.localToWorld(b);
          obj.localToWorld(c);

          let lineAB = new THREE.Line3(a, b);
          let lineBC = new THREE.Line3(b, c);
          let lineCA = new THREE.Line3(c, a);

          this.setPointOfIntersection(lineAB, clippingPlane, positions, "ball");
          this.setPointOfIntersection(lineBC, clippingPlane, positions, "ball");
          this.setPointOfIntersection(lineCA, clippingPlane, positions, "ball");

          this.setPointOfIntersection(lineAB, instepClippingPlane, positions, "instep");
          this.setPointOfIntersection(lineBC, instepClippingPlane, positions, "instep");
          this.setPointOfIntersection(lineCA, instepClippingPlane, positions, "instep");

          this.setPointOfIntersection(lineAB, longHeelclippingPlane, positions, "longHeel");
          this.setPointOfIntersection(lineBC, longHeelclippingPlane, positions, "longHeel");
          this.setPointOfIntersection(lineCA, longHeelclippingPlane, positions, "longHeel");

          this.setPointOfIntersection(lineAB, shortHeelclippingPlane, positions, "shortHeel");
          this.setPointOfIntersection(lineBC, shortHeelclippingPlane, positions, "shortHeel");
          this.setPointOfIntersection(lineCA, shortHeelclippingPlane, positions, "shortHeel");

          this.setPointOfIntersection(lineAB, ankleclippingPlane, positions, "ankle");
          this.setPointOfIntersection(lineBC, ankleclippingPlane, positions, "ankle");
          this.setPointOfIntersection(lineCA, ankleclippingPlane, positions, "ankle");

          this.setPointOfIntersection(lineAB, testclippingPlane, positions, "test");
          this.setPointOfIntersection(lineBC, testclippingPlane, positions, "test");
          this.setPointOfIntersection(lineCA, testclippingPlane, positions, "test");
        }

        lines.geometry.setAttribute(
          "position",
          new THREE.BufferAttribute(new Float32Array(positions), 3)
        );
      }

    });

    // Calculate total distance
    console.log("circumference ball: ", this.calculateLengthsBetweenPointss(this.ballCircumferencePoints))
    console.log("circumference instep: ", this.calculateLengthsBetweenPointss(this.instepCircumferencePoints))
    console.log("circumference longHeel: ", this.calculateLengthsBetweenPointss(this.longHeelCircumferencePoints))
    console.log("circumference shortHeel: ", this.calculateLengthsBetweenPointss(this.shortHeelCircumferencePoints))
    console.log("circumference ankle: ", this.calculateLengthsBetweenPointss(this.ankleCircumferencePoints))
    console.log("circumference test: ", this.calculateLengthsBetweenPointss(this.testCircumferencePoints))

    let testPoint = this.getCenterPoint(this.testCircumferencePoints);
    this.addPoint(testPoint);

    // Crear un Vector3 en la posición deseada
    const origin = testPoint

    // Encontrar el ángulo en radianes correspondiente a 20 grados
    const angle = (20 * Math.PI) / 180;

    // Calcular los componentes x, y y z del vector de dirección utilizando trigonometría
    const direction = new THREE.Vector3(
      Math.cos(angle), // componente x
      0,               // componente y
      -Math.sin(angle), // componente z
    );

    // Crear un rayo desde el origen en la dirección especificada
    const raycaster = new THREE.Raycaster(origin, direction);

    // // Filtrar los objetos por nombre
    var filteredObjects = this.scene.children.filter(function (obj) {
      return obj.name === "loaded_file";
    });

    // Lanzar el rayo y obtener el primer objeto intersectado
    const intersects = raycaster.intersectObjects(filteredObjects);
    if (intersects.length > 0) {
      const firstObject = intersects[0].object;
      console.log("INTERSECTO!")
      console.log(intersects[0].point)
      this.addPoint(intersects[0].point)
    }


    console.log("center point heel: ", testPoint);

  }

  cubeWithOutline() {

    // Crea una instancia de EffectComposer
    this.compose = new EffectComposer(this.renderer);

    // Agrega el render pass a la instancia de EffectComposer
    var renderPass = new RenderPass(this.scene, this.camera);
    this.compose.addPass(renderPass);

    // Crea una instancia de OutlinePass y agrega la malla del cubo a los objetos seleccionados
    var outlinePass = new OutlinePass(new THREE.Vector2(window.innerWidth, window.innerHeight), this.scene, this.camera);
    outlinePass.renderToScreen = true;
    outlinePass.selectedObjects.push(this.mesh);

    // -- parameter config
    outlinePass.edgeStrength = 60;
    outlinePass.edgeGlow = 0;
    outlinePass.edgeThickness = 5;
    outlinePass.pulsePeriod = 0;
    outlinePass.usePatternTexture = false; // patter texture for an object mesh
    outlinePass.visibleEdgeColor.set("#CCCCCC"); // set basic edge color
    outlinePass.hiddenEdgeColor.set("#CCCCCC"); // set edge color when it hidden by other objects
    outlinePass.overlayMaterial.blending = THREE.CustomBlending

    this.compose.addPass(outlinePass);

  }



  getCenterPoint(vectorList) {
    var sum = new THREE.Vector3();
    var vectorCount = vectorList.length;
    for (var i = 0; i < vectorCount; i++) {
      sum.add(vectorList[i]);
    }
    return sum.divideScalar(vectorCount);
  }

  setPointOfIntersection(line, planarSrf, pos, measurementType) {
    const intersect = planarSrf.intersectLine(line, new THREE.Vector3());
    if (intersect !== null) {
      let vec = intersect.clone();
      pos.push(vec.x);
      pos.push(vec.y);
      pos.push(vec.z);

      // Add to list
      if (measurementType == "ball") {
        this.ballCircumferencePoints.push(vec);
      }

      if (measurementType == "instep") {
        this.instepCircumferencePoints.push(vec);
      }

      if (measurementType == "longHeel") {
        this.longHeelCircumferencePoints.push(vec);
      }

      if (measurementType == "shortHeel") {
        this.shortHeelCircumferencePoints.push(vec);
      }

      if (measurementType == "ankle") {
        this.ankleCircumferencePoints.push(vec);
      }

      if (measurementType == "test") {
        this.testCircumferencePoints.push(vec);
      }
    }
  }

  calculateLengthsBetweenPoints(points: THREE.Vector3[]) {

    let totalDistance = 0;
    let currentVector = points[0];
    let distances = {};

    for (let i = 1; i < points.length; i++) {
      let nextVector = points[i];
      let key = nextVector.x + ',' + nextVector.y + ',' + nextVector.z;

      if (!(key in distances)) {
        let distance = currentVector.distanceTo(nextVector);
        this.addLine(nextVector, 0xbbbbbb, currentVector)
        distances[key] = distance;
        totalDistance += distance;
      }

      currentVector = nextVector;
    }

    return totalDistance;
  }

  calculateLengthsBetweenPointss(points: Vector3[]) {

    if (points.length > 0) {
      const orderedPoints = []; // La lista ordenada de puntos
      const unvisitedPoints = new Set(points); // La lista de puntos no visitados

      // Encuentra el punto más cercano al origen para comenzar la lista ordenada
      const start = unvisitedPoints.values().next().value;
      let current = start;
      orderedPoints.push(current);
      unvisitedPoints.delete(current);

      // Itera hasta que todos los puntos estén visitados
      while (unvisitedPoints.size > 0) {
        let closestDistance = Infinity;
        let closestPoint;

        // Encuentra el punto no visitado más cercano al punto actual
        for (const p of unvisitedPoints) {
          const distance = current.distanceTo(p);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPoint = p;
          }
        }

        // Añade el punto más cercano a la lista ordenada y marca como visitado
        orderedPoints.push(closestPoint);
        unvisitedPoints.delete(closestPoint);

        // Establece el punto actual al punto más cercano
        current = closestPoint;
      }

      // Añade el primer punto de nuevo para cerrar el circuito
      orderedPoints.push(start);

      // Calcula las longitudes de línea entre cada par de puntos ordenados
      // const lengths = [];
      var totalDistance = 0;
      for (let i = 0; i < orderedPoints.length - 1; i++) {
        const distance = orderedPoints[i].distanceTo(orderedPoints[i + 1]);
        // lengths.push(distance);
        totalDistance += distance;
      }

      console.log("distance: ", totalDistance)

      return totalDistance;
    }

    return 0

  }

  calculateFootMeasurements() {
    //this.ApplyColorDegradation();
    let minMaxCoords = this.getMinumumAndMaximumXVectors();
    minMaxCoords.maxX.z = 55;
    minMaxCoords.minX.z = 55;

    // add lines between max and min X
    this.createWideLine(minMaxCoords.minX, minMaxCoords.maxX, new THREE.Color(0x00FF00), 6);
    this.plantarFootMeasurements.length = minMaxCoords.minX.distanceTo(minMaxCoords.maxX);

    minMaxCoords.rightSideMaximumY.superior.z = 55;
    minMaxCoords.rightSideMaximumY.inferior.z = 55;

    //add line between
    if (this.fileLoaded.name.includes("right")) {
      minMaxCoords.rightSideMaximumY.superior.y += 6;
      minMaxCoords.rightSideMaximumY.inferior.y += 6;
      this.createWideLine(minMaxCoords.rightSideMaximumY.superior, minMaxCoords.rightSideMaximumY.inferior, new THREE.Color(0x350f44), 60)
    }

    let sideCords
    this.fileLoaded.name.includes("left") ? sideCords = minMaxCoords.leftSideMinimumY : sideCords = minMaxCoords.rightSideMaximumY

    let firstPoint = new Vector2(sideCords.inferior.x, sideCords.inferior.y)
    let secondPoint = new Vector2(sideCords.superior.x, sideCords.superior.y)
    const angulo = Math.atan2(secondPoint.y - firstPoint.y, secondPoint.x - firstPoint.x);

    let rotationAngle = angulo;

    console.log("Angle :", rotationAngle)


    minMaxCoords.leftSideMinimumY.superior.z = 55;
    minMaxCoords.leftSideMinimumY.inferior.z = 55;

    //add line between
    if (this.fileLoaded.name.includes("left")) {
      minMaxCoords.leftSideMinimumY.superior.y -= 6;
      minMaxCoords.leftSideMinimumY.inferior.y -= 6;
      this.createWideLine(minMaxCoords.leftSideMinimumY.superior, minMaxCoords.leftSideMinimumY.inferior, new THREE.Color(0x350f44), 60)
    }


    // Add lines between 1st and 5ft met
    this.aligningPoints[1].z = 55
    this.aligningPoints[2].z = 55
    this.createWideLine(this.aligningPoints[1], this.aligningPoints[2], new THREE.Color(0x350f44), 60)

    // Add line between metas and max X
    const midpoint = new THREE.Vector3();
    midpoint.addVectors(this.aligningPoints[1], this.aligningPoints[2]).multiplyScalar(0.5);
    midpoint.z = 55;
    this.plantarFootMeasurements.metatarsalSupport = midpoint.distanceTo(minMaxCoords.maxX);
    this.createWideLine(midpoint, minMaxCoords.maxX, new THREE.Color(0x99CCFF));


    // Add line at 33% of length of foot (direction to the arch)
    //const point = new THREE.Vector3();

    // Obtener la dirección y la longitud de la línea
    const direccion = new THREE.Vector3().subVectors(minMaxCoords.minX, minMaxCoords.maxX);
    const longitud = direccion.length();

    // Obtener el punto a un tercio de la longitud de la línea
    const tercio = longitud * 0.33;
    const tercio2 = longitud * 0.37;
    const point33Percent = minMaxCoords.maxX.clone().add(direccion.normalize().multiplyScalar(tercio));
    const point37Percent = minMaxCoords.maxX.clone().add(direccion.normalize().multiplyScalar(tercio2));

    // Marcar el punto en la escena
    const geometria = new THREE.SphereGeometry(3, 16, 16);
    const material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
    const esfera = new THREE.Mesh(geometria, material);
    //esfera.position.copy(point);
    //this.scene.add(esfera);

    let destinationPoint = new Vector3(point33Percent.x, this.fileLoaded.name.includes("left") ? point33Percent.y + 50 : point33Percent.y - 50, point33Percent.z)
    this.addLine(point33Percent, 0x350f44, destinationPoint, true, false, rotationAngle)

    let destinationPoint2 = new Vector3(point37Percent.x, this.fileLoaded.name.includes("left") ? point37Percent.y + 50 : point37Percent.y - 50, point37Percent.z)
    this.addLine(point37Percent, 0x350f44, destinationPoint2, true, false, rotationAngle)

    this.removeAligningPoints();
  }

  SaveCapture() {

    if (!this.fileLoaded.paid) {
      Swal.fire('警告', '文件未解锁。', 'error');
      return;
    }

    this.generateColorLegend();
    this.ApplyColorDegradation();
    console.log(this.degradationColors);

    // Remove floor plane
    this.scene.children.map((children) => {
      if (children.name == "floor_plane") {
        this.scene.remove(children)
      }
    })

    var width = 1000
    var height = 600;
    var aspectRatio = width / height;

    var height = width / aspectRatio;

    this.renderer.setSize(width, height);

    var left = -width / 2 / 2;
    var right = width / 2 / 2;
    var top = height / 2 / 2;
    var bottom = -height / 2 / 2;

    // Obtener el bounding box
    var boundingBox = new THREE.Box3();
    boundingBox.setFromObject(this.mesh);
    var min = boundingBox.min;
    var max = boundingBox.max;

    this.camera.updateProjectionMatrix();



    let cameraBeforeModifies = this.camera;
    this.camera = new THREE.OrthographicCamera(left, right, top, bottom);
    // -100 para tener la cámara centrada al objecto
    this.camera.position.set(-100, 0, 100);
    // rotate camera 90 degrees
    this.camera.up.set(0, 0, 1);
    this.camera.lookAt(this.camera.position);
    this.camera.updateMatrixWorld()

    this.renderer.render(this.scene, this.camera);
    this.cubeWithOutline()

    this.calculateFootMeasurements();

    setTimeout(() => {
      const dataURL = this.renderer.domElement.toDataURL("image/jpeg", 1.0);


      // Use jsPDF to save the image as a PDF
      const pdf = new jsPDF();

      var pdfWidth = 525;
      var pdfHeight = 312;
      var pdfX = pdfWidth / 3;
      pdf.addImage(dataURL, 'JPEG', -pdfX, -10, pdfWidth, pdfHeight);

      // Add measurement text
      // Dibujar un círculo verde
      pdf.setFillColor(0, 255, 0); // Establecer el color de relleno en verde
      pdf.circle(150, 250, 5, 'F'); // Dibujar un círculo en las coordenadas (50,50) con un radio de 20

      // Añadir texto al lado del círculo
      pdf.setFontSize(12); // Establecer el tamaño de fuente en 12
      pdf.text(this.translateService.instant('FOOT_LENGTH') + ' ' + this.plantarFootMeasurements.length.toFixed(0) + 'mm', 157, 252); // Colocar el texto a 80 unidades de distancia desde el borde izquierdo y 55 unidades de distancia desde el borde superior


      // Añadir texto al lado del círculo
      pdf.setFontSize(12); // Establecer el tamaño de fuente en 12
      pdf.text(this.translateService.instant('OFFSET') + ' ' + (this.plantarFootMeasurements.length + 12).toFixed(0) + 'mm', 157, 264); // Colocar el texto a 80 unidades de distancia desde el borde izquierdo y 55 unidades de distancia desde el borde superior

      // Add measurement text
      // Dibujar un círculo verde
      pdf.setFillColor(153, 204, 255); // Establecer el color de relleno en verde
      pdf.circle(150, 274, 5, 'F'); // Dibujar un círculo en las coordenadas (50,50) con un radio de 20


      // Añadir texto al lado del círculo
      pdf.setFontSize(12); // Establecer el tamaño de fuente en 12
      pdf.text(this.translateService.instant('METATARSAL_SUPPORT') + ' ' + this.plantarFootMeasurements.metatarsalSupport.toFixed(0) + 'mm', 157, 276); // Colocar el texto a 80 unidades de distancia desde el borde izquierdo y 55 unidades de distancia desde el borde superior

      pdf.save(`${this.fileLoaded.name}.pdf`);

      // remove measurement line and text
      const objectsToRemove = this.scene.children.filter((child) => {
        return child.name && child.name.includes("measurement");
      });
      objectsToRemove.forEach((child) => {
        console.log(child);
        this.scene.remove(child);
      });

      this.sceneLinesHelper.clear()

      // remove compose (black outline)
      this.compose = null;

      // Change the Gradient to Normal color
      this.mesh.material = new THREE.MeshPhongMaterial({ color: 0xF1C27D, transparent: false, side: THREE.DoubleSide, clippingPlanes: this.clippingPlanes, flatShading: false });

      // Add Again the floor plane
      this.addFloorPlane()

      this.camera = cameraBeforeModifies;
      this.orbit = new OrbitControls(this.camera, this.renderer.domElement)
      // set the normal width and height
      this.renderer.setSize(window.innerWidth, window.innerHeight);
      // Open the data URL in a new tab or download it
      //window.open(dataURL, "_blank");
    }, 10)


  }

  createWideLine(startPoint: THREE.Vector3, finishPoint: THREE.Vector3, color: THREE.Color, extendByXmm = 0, rotationInDegrees = 0) {
    // Definir los dos puntos que especifican la dirección del cilindro
    const pointA = startPoint;
    const pointB = finishPoint;

    // Calcular la dirección del cilindro
    const direction = new THREE.Vector3().subVectors(pointB, pointA).normalize();

    // Calcular la distancia entre los dos puntos
    const distance = pointA.distanceTo(pointB);

    // Calcular el punto medio entre los dos puntos
    const midpoint = new THREE.Vector3().addVectors(pointA, pointB).multiplyScalar(0.5);

    // Calcular la distancia adicional para alargar la línea
    const additionalDistance = extendByXmm * 2;

    // Calcular el nuevo punto final utilizando la dirección y la distancia adicional
    const newPointB = new THREE.Vector3().copy(direction).multiplyScalar(distance + additionalDistance).add(pointA);

    // Calcular el nuevo punto medio entre los dos puntos
    const newMidpoint = new THREE.Vector3().addVectors(pointA, newPointB).multiplyScalar(0.5);

    // Calcular la nueva distancia entre los dos puntos
    const newDistance = pointA.distanceTo(newPointB);

    // Calcular la distancia para mover la línea y centrarla
    const moveDistance = additionalDistance / 2;

    // Crear la geometría del cilindro
    const radiusTop = 1;
    const radiusBottom = 1;
    const height = newDistance;
    const radialSegments = 8;
    const heightSegments = 1;
    const openEnded = false;
    const geometry = new THREE.CylinderGeometry(
      radiusTop,
      radiusBottom,
      height,
      radialSegments,
      heightSegments,
      openEnded
    );

    // Orientar el cilindro en la dirección correcta
    const up = new THREE.Vector3(0, 1, 0); // vector "up" arbitrario
    const quaternion = new THREE.Quaternion().setFromUnitVectors(up, direction);
    geometry.applyQuaternion(quaternion);

    // Mover el cilindro hacia el nuevo punto medio
    const cylinder = new THREE.Mesh(
      geometry,
      new THREE.MeshBasicMaterial({ color })
    );
    cylinder.position.copy(newMidpoint);

    // Mover el cilindro para centrar la línea
    const moveVector = direction.clone().multiplyScalar(-moveDistance); // Mover en dirección opuesta
    cylinder.position.add(moveVector);

    if (rotationInDegrees) {
      let pivotPoint = new THREE.Object3D()
      pivotPoint.position.set(startPoint.x, startPoint.y, startPoint.z);

      this.sceneLinesHelper.add(pivotPoint);
      this.sceneLinesHelper.add(cylinder);

      pivotPoint.add(cylinder);

    } else {
      this.sceneLinesHelper.add(cylinder);
    }

  }

  getMinumumAndMaximumXVectors(): { maxX: Vector3, minX: Vector3, rightSideMaximumY: { superior: Vector3, inferior: Vector3 }, leftSideMinimumY: { superior: Vector3, inferior: Vector3 } } {
    const positionAttribute = this.mesh.geometry.getAttribute('position');
    const positionArray = positionAttribute.array;
    let minX = Infinity;
    let minXCoord: Vector3;

    let maxX = -Infinity;
    let maxXCoord: Vector3;

    let lowerPositiveY = -Infinity;
    let lowerPositiveYCoord: Vector3;
    let upperPositiveY = -Infinity;
    let upperPositiveYCoord: Vector3;

    let lowerNegativeY = Infinity;
    let lowerNegativeYCoord: Vector3;
    let upperNegativeY = Infinity;
    let upperNegativeYCoord: Vector3;

    // Recorremos los valores del buffer de posición
    for (let i = 0; i < positionArray.length; i += 3) {
      const x = positionArray[i];
      if (x < minX) {
        minX = x;
        minXCoord = new Vector3(positionArray[i], positionArray[i + 1], positionArray[i + 2])
      }

      if (x > maxX) {
        maxX = x;
        maxXCoord = new Vector3(positionArray[i], positionArray[i + 1], positionArray[i + 2])
      }
    }

    // Recorremos los valores del buffer de posición de los puntos externos para generar la tangente
    const point = new THREE.Vector3();
    point.addVectors(minXCoord, maxXCoord).multiplyScalar(0.10);
    //this.addCircle(point.x, point.y, point.z);

    for (let i = 0; i < positionArray.length; i += 3) {
      const x = positionArray[i];
      const y = positionArray[i + 1];

      // If es the bottom part of the foot first 33% and bigger than other Y replace it
      if (y > lowerPositiveY && x > point.x) {
        lowerPositiveY = y;
        lowerPositiveYCoord = new Vector3(positionArray[i], positionArray[i + 1], positionArray[i + 2])
      }

      // If es the bottom part of the foot first 33% and bigger than other Y replace it
      if (y > upperPositiveY && x < point.x) {
        upperPositiveY = y;
        upperPositiveYCoord = new Vector3(positionArray[i], positionArray[i + 1], positionArray[i + 2])
      }


      // If es the bottom part of the foot first 33% and lower than other Y replace it
      if (y < lowerNegativeY && x > point.x) {
        lowerNegativeY = y;
        lowerNegativeYCoord = new Vector3(positionArray[i], positionArray[i + 1], positionArray[i + 2])
      }

      // If es the bottom part of the foot first 33% and lower than other Y replace it
      if (y < upperNegativeY && x < point.x) {
        upperNegativeY = y;
        upperNegativeYCoord = new Vector3(positionArray[i], positionArray[i + 1], positionArray[i + 2])
      }
    }



    return {
      maxX: maxXCoord,
      minX: minXCoord,
      rightSideMaximumY: {
        superior: upperPositiveYCoord,
        inferior: lowerPositiveYCoord
      },
      leftSideMinimumY: {
        superior: upperNegativeYCoord,
        inferior: lowerNegativeYCoord
      }
    };
  }



  generateSkeleton() {

    // Create a bone hierarchy
    var bone1 = new THREE.Bone();
    var bone2 = new THREE.Bone();

    bone2.position.x = -100;
    bone1.add(bone2);

    var bone3 = new THREE.Bone();
    bone3.position.x = -50;
    bone2.add(bone3);

    var bone4 = new THREE.Bone();
    bone4.position.x = -25;
    bone3.add(bone4);

    var bone5 = new THREE.Bone();
    bone5.position.z = 100;
    bone4.add(bone5);

    // Create a skeleton from the bone hierarchy
    var skeleton = new THREE.Skeleton([bone1, bone2, bone3, bone4, bone5]);

    // Create a SkinnedMesh
    var geometry = this.mesh.geometry
    var material = new THREE.MeshBasicMaterial({ color: 0xff0000 });
    var skinnedMesh = new THREE.SkinnedMesh(geometry, material);

    // Set the skeleton to the SkinnedMesh
    skinnedMesh.add(bone1);
    skinnedMesh.bind(skeleton, skinnedMesh.matrixWorld);

    // Assign vertex weights to the bones
    var skinIndices = [];
    var skinWeights = [];
    for (var i = 0; i < geometry.attributes.position.count; i++) {
      var skinIndex = 0;
      var skinWeight = 1;
      skinIndices.push(skinIndex, skinIndex, skinIndex, skinIndex);
      skinWeights.push(skinWeight, skinWeight, skinWeight, skinWeight);
    }
    geometry.setAttribute('skinIndex', new THREE.Uint16BufferAttribute(skinIndices, 4));
    geometry.setAttribute('skinWeight', new THREE.Float32BufferAttribute(skinWeights, 4));

    // Add the SkinnedMesh to the scene
    this.scene.add(skinnedMesh);

    this.skeleton = new THREE.SkeletonHelper(skinnedMesh);
    this.scene.add(this.skeleton);

    this.control = new TransformControls(this.camera, this.renderer.domElement)
    this.control.setSpace('world');
    this.control.addEventListener('change', () => {
      this.renderer.render(this.scene, this.camera);
    });

    // Disable orbit control on modify control
    this.control.addEventListener('dragging-changed', (event) => {
      this.orbit.enabled = !event.value;
    });

    this.control.attach(this.skeleton.bones[0]);
    this.scene.add(this.control);

    this.scene.updateMatrixWorld();
  }


  getSkeleton() {

    let loader = new GLTFLoader();

    var obj = null;
    var bones = null;

    // Load a glTF resource
    loader.load(
      // resource URL
      // 'https://wikyscan-2021.s3.eu-west-1.amazonaws.com/00357ad1-6e37-4509-811e-8ec3517ae4b3/9b2e72d2-53a0-4499-ba3e-f077451aa916/test.glb',
      'http://localhost:8097/',
      // 'https://wikyscan-2021.s3.eu-west-1.amazonaws.com/00357ad1-6e37-4509-811e-8ec3517ae4b3/9b2e72d2-53a0-4499-ba3e-f077451aa916/ImageToStl_com_model.glb',
      // called when the resource is loaded
      (gltf) => {

        // gltf.scene.traverse( function ( child ) {

        //     if ( child.type == 'SkinnedMesh' ) {

        //         obj = {animations: gltf.animations, mesh: child};

        //         if( bones ){

        //             obj.mesh.add(bones);

        //         }

        //     }else if ( child.name.indexOf('Armature') != -1 ) {

        //         if( child.children.length ){

        //             for( var ii=0, len2=child.children.length ; ii<len2; ii++ ){

        //                 if( child.children[ii].type == 'Bone' ){

        //                     if( obj ){

        //                         obj.mesh.add(child.children[0]);

        //                     }else{

        //                         bones = child.children[0];

        //                     }

        //                 }else if( child.children[ii].type == 'SkinnedMesh' ){

        //                     obj = {animations: gltf.animations, mesh: child.children[ii]};

        //                     if( bones ){

        //                         obj.mesh.add(bones);

        //                     }

        //                 }

        //             }

        //         }0

        //     }

        // });	

        // obj.mesh.rotation.x = Math.PI / 2;
        // this.scene.add(obj.mesh)
        // this.scene.updateMatrixWorld()



        let model = gltf.scene;


        model.rotation.x = Math.PI / 2;

        this.scene.add(model);

        model.traverse(function (object) {

          if ((object as Mesh).isMesh) {
            object.castShadow = true;
            object.name = 'loaded_file'
          }


        });

        //

        this.skeleton = new THREE.SkeletonHelper(model);
        this.skeleton.visible = true;
        this.scene.add(this.skeleton);

        // controls
        this.orbit = new OrbitControls(this.camera, this.renderer.domElement)
        this.orbit.update();
        this.orbit.addEventListener('change', () => {
          this.renderer.render(this.scene, this.camera);
        });

        this.control = new TransformControls(this.camera, this.renderer.domElement)
        this.control.setSpace('world');
        this.control.addEventListener('change', () => {
          this.renderer.render(this.scene, this.camera);
        });

        // Disable orbit control on modify control
        this.control.addEventListener('dragging-changed', (event) => {
          this.orbit.enabled = !event.value;
        });

        this.control.attach(this.skeleton.bones[2]);
        this.scene.add(this.control);

        this.scene.updateMatrixWorld();


        // let helper = new THREE.SkeletonHelper( obj.mesh );
        // helper.visible = true;
        // this.scene.add(helper);


        // console.log(this.scene);
        // gltf.animations; // Array<THREE.AnimationClip>
        // gltf.scene; // THREE.Group
        // gltf.scenes; // Array<THREE.Group>
        // gltf.cameras; // Array<THREE.Camera>
        // gltf.asset; // Object


      },
      // called while loading is progressing
      function (xhr) {

        console.log((xhr.loaded / xhr.total * 100) + '% loaded');

      },
      // called when loading has errors
      function (error) {

        console.log(error)
        console.log('An error happened');

      }
    )
  }

  toggleTranslateMesh() {
    this.control.visible = true;
    this.control.enabled = true;
    this.control.setMode('translate')
  }

  toggleRotateMesh() {
    this.control.visible = true;
    this.control.enabled = true;
    this.control.setMode('rotate')
  }


  scaleModel(factor: number) {
    if (this.mesh) {
      this.mesh.scale.set(factor, factor, factor);
    }
  }

  applyTransformations() {

    console.log("apply transformations")
    // Rotate only when it's not paid
    if (!this.fileLoaded.paid) {
      let transformations = this.rotationsAndTransformations;

      //Centrar en escena
      if (transformations.centerOnScene) {
        this.mesh.geometry.center(); // Centra los vértices
        this.mesh.position.set(0, 0, 0); // Asegura que el mesh esté en el origen
      }

      // Rotaciones (solo si existen)
      if (transformations.rotationX != null) {
        this.mesh.rotation.x = THREE.MathUtils.degToRad(transformations.rotationX);
      }
      if (transformations.rotationY != null) {
        this.mesh.rotation.y = THREE.MathUtils.degToRad(transformations.rotationY);
      }
      if (transformations.rotationZ != null) {
        this.mesh.rotation.z = THREE.MathUtils.degToRad(transformations.rotationZ);
      }

      // Translaciones (solo si existen)
      if (transformations.translationX != null) {
        this.mesh.position.x = transformations.translationX;
      }
      if (transformations.translationY != null) {
        this.mesh.position.y = transformations.translationY;
      }
      if (transformations.translationZ != null) {
        this.mesh.position.z = transformations.translationZ;
      }
    }


  }

  setStepperToStep1() {
    this.currentStepIndex = 1;

    if (!this.stepper) {
      console.warn('⚠️ Stepper not available, but currentStepIndex set to 1');
      return;
    }

    this.stepper.activeStep = 1;

    if ('activeIndex' in this.stepper) {
      (this.stepper as any).activeIndex = 1;
    }
  }

  initializeStepper() {
    if (!this.showSetLandmarksStep && this.step1Completed) {
      this.currentStepIndex = 1;
    } else {
      this.currentStepIndex = 0;
    }

    // Si el stepper está disponible, también configurarlo directamente
    if (this.stepper) {
      this.stepper.activeStep = this.currentStepIndex;
    }
  }

  checkFileForLandmarksAndSetStepper(file: ScanFile) {

    // Resetear el estado inicial
    this.showSetLandmarksStep = true;
    this.step1Completed = false;
    this.currentStepIndex = 0;

    // Obtener información del scan para verificar landmarks
    this.scanService.getOne(this.scanId).subscribe({
      next: (scanFound) => {
        if (scanFound.data?.Landmarks && scanFound.data.Landmarks.length > 0) {
          this.showSetLandmarksStep = false;
          this.step1Completed = true;
          this.currentStepIndex = 1; // Ir al paso 1 (Modify Scan)
        } else {
          this.showSetLandmarksStep = true;
          this.step1Completed = false;
          this.currentStepIndex = 0; // Quedarse en paso 0 (Set Landmarks)
        }

        // Forzar actualización del stepper
        this.cdr.detectChanges();

        // Si el stepper está disponible, configurarlo directamente también
        if (this.stepper) {
          this.stepper.activeStep = this.currentStepIndex;
          this.cdr.detectChanges();
        }
      },
      error: (error) => {
        console.error('❌ Error checking landmarks for file:', error);
        this.currentStepIndex = 0;
        this.cdr.detectChanges();
      }
    });
  }

  // Check if at least one scan file is paid
  hasAtLeastOnePaidFile(): boolean {
    return this.files && this.files.length > 0 && this.files.some(file => file.paid);
  }

  showProductSelector() {
    this.productSelector.showDialog();
  }

  onProductSelected(product: Product3DToDesign) {
    this.navigateToDesignEngine(product);
  }

  navigateToDesignEngine(product: Product3DToDesign) {
    // Get current query parameters to preserve iframeToken if present
    const currentQueryParams = this.route.snapshot.queryParams;
    const iframeToken = currentQueryParams['iframeToken'];

    const queryParams: any = {
      id: this.scanId,
      productName: product.name,
      fromViewer: 'true'
    };

    // Add iframeToken if it exists in current URL
    if (iframeToken) {
      queryParams.iframeToken = iframeToken;
    }

    this.router.navigate(['/design/design-engine'], {
      queryParams: queryParams
    });
  }
}